var items = {
  "block.minecraft.acacia_button": "Dugme od bagrema",
  "block.minecraft.acacia_door": "Vrata od bagrema",
  "block.minecraft.acacia_fence": "Ograda od bagrema",
  "block.minecraft.acacia_fence_gate": "Kapija od bagrema",
  "block.minecraft.acacia_hanging_sign": "Akacijin viseći znak",
  "block.minecraft.acacia_leaves": "Lišće akacije",
  "block.minecraft.acacia_log": "Drvo bagrema",
  "block.minecraft.acacia_planks": "Bagremove daske",
  "block.minecraft.acacia_pressure_plate": "Potisna ploča bagrema",
  "block.minecraft.acacia_sapling": "Mladica bagrema",
  "block.minecraft.acacia_shelf": "Polica od Bagrema",
  "block.minecraft.acacia_sign": "Znak od akacije",
  "block.minecraft.acacia_slab": "Ploča bagrema",
  "block.minecraft.acacia_stairs": "Stepenice bagremovog drveta",
  "block.minecraft.acacia_trapdoor": "Okno od bagrema",
  "block.minecraft.acacia_wall_hanging_sign": "Akacijin zidni viseći znak",
  "block.minecraft.acacia_wall_sign": "Znak od akacije za zid",
  "block.minecraft.acacia_wood": "Drvo bagrema",
  "block.minecraft.activator_rail": "Pruga sa aktivatorom",
  "block.minecraft.air": "Vazduh",
  "block.minecraft.allium": "Luk",
  "block.minecraft.amethyst_block": "Blok ametista",
  "block.minecraft.amethyst_cluster": "Hrpa ametista",
  "block.minecraft.ancient_debris": "Drevni ostaci",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Plota od andezita",
  "block.minecraft.andesite_stairs": "Stepenice od andezita",
  "block.minecraft.andesite_wall": "Zid od andezita",
  "block.minecraft.anvil": "Nakovanj",
  "block.minecraft.attached_melon_stem": "Prikačena stabljika lubenice",
  "block.minecraft.attached_pumpkin_stem": "Prikačena stabljika bundeve",
  "block.minecraft.azalea": "Azaleja",
  "block.minecraft.azalea_leaves": "Lišće azaleje",
  "block.minecraft.azure_bluet": "Plava hustonija",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Blok od bambusa",
  "block.minecraft.bamboo_button": "Bambusovo dugme",
  "block.minecraft.bamboo_door": "Vrata od bambusa",
  "block.minecraft.bamboo_fence": "Bambusova ograda",
  "block.minecraft.bamboo_fence_gate": "Bambusova kapija",
  "block.minecraft.bamboo_hanging_sign": "Bambusov viseći znak",
  "block.minecraft.bamboo_mosaic": "Bambus mozaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusova mozaik ploča",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusove mozaik stepenice",
  "block.minecraft.bamboo_planks": "Bambusove daske",
  "block.minecraft.bamboo_pressure_plate": "Bambusova potisna ploča",
  "block.minecraft.bamboo_sapling": "Pupoljak bambusa",
  "block.minecraft.bamboo_shelf": "Polica od Bambusa",
  "block.minecraft.bamboo_sign": "Bambusov znak",
  "block.minecraft.bamboo_slab": "Bambusova ploča",
  "block.minecraft.bamboo_stairs": "Bambusove stepenice",
  "block.minecraft.bamboo_trapdoor": "Bambusovo okno",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambusov zidni viseći znak",
  "block.minecraft.bamboo_wall_sign": "Bambusov zidni znak",
  "block.minecraft.banner.base.black": "Potpuno crno polje",
  "block.minecraft.banner.base.blue": "Potpuno plavo polje",
  "block.minecraft.banner.base.brown": "Potpuno braon polje",
  "block.minecraft.banner.base.cyan": "Potpuno tirkizno polje",
  "block.minecraft.banner.base.gray": "Potpuno sivo polje",
  "block.minecraft.banner.base.green": "Potpuno zeleno polje",
  "block.minecraft.banner.base.light_blue": "Potpuno svetlo plavo polje",
  "block.minecraft.banner.base.light_gray": "Potpuno svetlo sivo polje",
  "block.minecraft.banner.base.lime": "Potpuno svetlo zeleno polje",
  "block.minecraft.banner.base.magenta": "Potpuno magenta polje",
  "block.minecraft.banner.base.orange": "Potpuno narandžasto polje",
  "block.minecraft.banner.base.pink": "Potpuno roze polje",
  "block.minecraft.banner.base.purple": "Potpuno ljubičasto polje",
  "block.minecraft.banner.base.red": "Potpuno crveno polje",
  "block.minecraft.banner.base.white": "Potpuno belo polje",
  "block.minecraft.banner.base.yellow": "Potpuno žuto polje",
  "block.minecraft.banner.border.black": "Crni okvir",
  "block.minecraft.banner.border.blue": "Plavi okvir",
  "block.minecraft.banner.border.brown": "Braon okvir",
  "block.minecraft.banner.border.cyan": "Tirkizni okvir",
  "block.minecraft.banner.border.gray": "Sivi okvir",
  "block.minecraft.banner.border.green": "Zeleni okvir",
  "block.minecraft.banner.border.light_blue": "Svetloplavi okvir",
  "block.minecraft.banner.border.light_gray": "Svetlosivi okvir",
  "block.minecraft.banner.border.lime": "Svetlozeleni okvir",
  "block.minecraft.banner.border.magenta": "Magenta okvir",
  "block.minecraft.banner.border.orange": "Narandžasti okvir",
  "block.minecraft.banner.border.pink": "Roze okvir",
  "block.minecraft.banner.border.purple": "Ljubičasti okvir",
  "block.minecraft.banner.border.red": "Crveni okvir",
  "block.minecraft.banner.border.white": "Beli okvir",
  "block.minecraft.banner.border.yellow": "Žuti okvir",
  "block.minecraft.banner.bricks.black": "Crne cigle",
  "block.minecraft.banner.bricks.blue": "Plave cigle",
  "block.minecraft.banner.bricks.brown": "Braon cigle",
  "block.minecraft.banner.bricks.cyan": "Tirkizna cigla",
  "block.minecraft.banner.bricks.gray": "Sive cigle",
  "block.minecraft.banner.bricks.green": "Zelene cigle",
  "block.minecraft.banner.bricks.light_blue": "Svetloplave cigle",
  "block.minecraft.banner.bricks.light_gray": "Svetlosive cigle",
  "block.minecraft.banner.bricks.lime": "Svetlozelene cigle",
  "block.minecraft.banner.bricks.magenta": "Magenta cigle",
  "block.minecraft.banner.bricks.orange": "Narandžaste cigle",
  "block.minecraft.banner.bricks.pink": "Roze cigle",
  "block.minecraft.banner.bricks.purple": "Ljubičaste cigle",
  "block.minecraft.banner.bricks.red": "Crvene cigle",
  "block.minecraft.banner.bricks.white": "Bele cigle",
  "block.minecraft.banner.bricks.yellow": "Žute cigle",
  "block.minecraft.banner.circle.black": "Crni kružić",
  "block.minecraft.banner.circle.blue": "Plavi kružić",
  "block.minecraft.banner.circle.brown": "Braon kružić",
  "block.minecraft.banner.circle.cyan": "Tirkizni kružić",
  "block.minecraft.banner.circle.gray": "Sivi kružić",
  "block.minecraft.banner.circle.green": "Zeleni kružić",
  "block.minecraft.banner.circle.light_blue": "Svetloplavi kružić",
  "block.minecraft.banner.circle.light_gray": "Svetlosivi kružić",
  "block.minecraft.banner.circle.lime": "Svetlozeleni kružić",
  "block.minecraft.banner.circle.magenta": "Magenta kružić",
  "block.minecraft.banner.circle.orange": "Narandžasti kružić",
  "block.minecraft.banner.circle.pink": "Roze kružić",
  "block.minecraft.banner.circle.purple": "Ljubičasti kružić",
  "block.minecraft.banner.circle.red": "Crveni kružić",
  "block.minecraft.banner.circle.white": "Beli kružić",
  "block.minecraft.banner.circle.yellow": "Žuti kružić",
  "block.minecraft.banner.creeper.black": "Crni Creeper",
  "block.minecraft.banner.creeper.blue": "Plavi Creeper",
  "block.minecraft.banner.creeper.brown": "Braon Creeper",
  "block.minecraft.banner.creeper.cyan": "Tirkizni Creeper",
  "block.minecraft.banner.creeper.gray": "Sivi Creeper",
  "block.minecraft.banner.creeper.green": "Zeleni Creeper",
  "block.minecraft.banner.creeper.light_blue": "Svetloplavi Creeper",
  "block.minecraft.banner.creeper.light_gray": "Svetlosivi Creeper",
  "block.minecraft.banner.creeper.lime": "Svetlozeleni Creeper",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper",
  "block.minecraft.banner.creeper.orange": "Narandžasti Creeper",
  "block.minecraft.banner.creeper.pink": "Roze Creeper",
  "block.minecraft.banner.creeper.purple": "Ljubičasti Creeper",
  "block.minecraft.banner.creeper.red": "Crveni Creeper",
  "block.minecraft.banner.creeper.white": "Beli Creeper",
  "block.minecraft.banner.creeper.yellow": "Žuti Creeper",
  "block.minecraft.banner.cross.black": "Crni Andrijin krst",
  "block.minecraft.banner.cross.blue": "Plavi Andrijin krst",
  "block.minecraft.banner.cross.brown": "Braon Andrijin krst",
  "block.minecraft.banner.cross.cyan": "Tirkizni Andrijin krst",
  "block.minecraft.banner.cross.gray": "Sivi Andrijin krst",
  "block.minecraft.banner.cross.green": "Zeleni Andrijin krst",
  "block.minecraft.banner.cross.light_blue": "Svetloplavi Andrijin krst",
  "block.minecraft.banner.cross.light_gray": "Svetlosivi Andrijin krst",
  "block.minecraft.banner.cross.lime": "Svetlozeleni Andrijin krst",
  "block.minecraft.banner.cross.magenta": "Magenta Andrijin krst",
  "block.minecraft.banner.cross.orange": "Narandžasti Andrijin krst",
  "block.minecraft.banner.cross.pink": "Roze Andrijin krst",
  "block.minecraft.banner.cross.purple": "Ljubičasti Andrijin krst",
  "block.minecraft.banner.cross.red": "Crveni Andrijin krst",
  "block.minecraft.banner.cross.white": "Beli Andrijin krst",
  "block.minecraft.banner.cross.yellow": "Žuti Andrijin krst",
  "block.minecraft.banner.curly_border.black": "Crni uvučeni okvir",
  "block.minecraft.banner.curly_border.blue": "Plavi uvučeni okvir",
  "block.minecraft.banner.curly_border.brown": "Braon uvučeni okvir",
  "block.minecraft.banner.curly_border.cyan": "Tirkizni uvučeni okvir",
  "block.minecraft.banner.curly_border.gray": "Sivi uvučeni okvir",
  "block.minecraft.banner.curly_border.green": "Zeleni uvučeni okvir",
  "block.minecraft.banner.curly_border.light_blue": "Svetloplavi uvučeni okvir",
  "block.minecraft.banner.curly_border.light_gray": "Svetlosivi uvučeni okvir",
  "block.minecraft.banner.curly_border.lime": "Svetlozeleni uvučeni okvir",
  "block.minecraft.banner.curly_border.magenta": "Magenta uvučeni okvir",
  "block.minecraft.banner.curly_border.orange": "Narandžasti uvučeni okvir",
  "block.minecraft.banner.curly_border.pink": "Roze uvučeni okvir",
  "block.minecraft.banner.curly_border.purple": "Ljubičasti uvučeni okvir",
  "block.minecraft.banner.curly_border.red": "Crveni uvučeni okvir",
  "block.minecraft.banner.curly_border.white": "Beli uvučeni okvir",
  "block.minecraft.banner.curly_border.yellow": "Žuti uvučeni okvir",
  "block.minecraft.banner.diagonal_left.black": "Crna leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.blue": "Plava leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.brown": "Braon leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.cyan": "Tirkizna leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.gray": "Siva leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.green": "Zelena leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.light_blue": "Svetloplava leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.light_gray": "Svetlosiva leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.lime": "Svetlozelena leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.orange": "Narandžasta leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.pink": "Roze leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.purple": "Ljubičasta leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.red": "Crvena leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.white": "Bela leva puna dijagonala",
  "block.minecraft.banner.diagonal_left.yellow": "Žuta leva puna dijagonala",
  "block.minecraft.banner.diagonal_right.black": "Crna desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.blue": "Plava desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.brown": "Braon desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.cyan": "Tirkizna desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.gray": "Siva desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.green": "Zelena desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.light_blue": "Svetloplava desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.light_gray": "Svetlosiva desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.lime": "Svetlozelena desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.orange": "Narandžasta desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.pink": "Roza desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.purple": "Ljubičasta desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.red": "Crvena desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.white": "Bela desna puna dijagonala",
  "block.minecraft.banner.diagonal_right.yellow": "Žuta desna puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.black": "Crna leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.blue": "Plava leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.brown": "Braon leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tirkizna gornje leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.gray": "Siva leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.green": "Zelena leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Svetloplava leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Svetlosiva leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.lime": "Svetlozelena leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.orange": "Narandžasta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.pink": "Roze leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.purple": "Ljubičasta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.red": "Crvena leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.white": "Bela leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_left.yellow": "Žuta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.black": "Crna leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.blue": "Plava leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.brown": "Braon leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tirkizna gornje desna puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.gray": "Siva obrnuta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.green": "Zelena leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Svetloplava leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Svetlosiva leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.lime": "Svetlozelena leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta obrnuta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.orange": "Narandžasta obrnuta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.pink": "Roze obrnuta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.purple": "Ljubičasta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.red": "Crvena leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.white": "Bela obrnuta leva puna dijagonala",
  "block.minecraft.banner.diagonal_up_right.yellow": "Žuta obrnuta leva puna dijagonala",
  "block.minecraft.banner.flow.black": "Crni tok",
  "block.minecraft.banner.flow.blue": "Plavi tok",
  "block.minecraft.banner.flow.brown": "Braon tok",
  "block.minecraft.banner.flow.cyan": "Tirkizni tok",
  "block.minecraft.banner.flow.gray": "Sivi tok",
  "block.minecraft.banner.flow.green": "Zeleni tok",
  "block.minecraft.banner.flow.light_blue": "Svetloplavi tok",
  "block.minecraft.banner.flow.light_gray": "Svetlosivi tok",
  "block.minecraft.banner.flow.lime": "Svetlozeleni tok",
  "block.minecraft.banner.flow.magenta": "Magenta tok",
  "block.minecraft.banner.flow.orange": "Narandžasti tok",
  "block.minecraft.banner.flow.pink": "Roze tok",
  "block.minecraft.banner.flow.purple": "Ljubičasti tok",
  "block.minecraft.banner.flow.red": "Crveni tok",
  "block.minecraft.banner.flow.white": "Beli tok",
  "block.minecraft.banner.flow.yellow": "Žuti tok",
  "block.minecraft.banner.flower.black": "Crni cvet",
  "block.minecraft.banner.flower.blue": "Plavi cvet",
  "block.minecraft.banner.flower.brown": "Braon cvet",
  "block.minecraft.banner.flower.cyan": "Tirkizni cvet",
  "block.minecraft.banner.flower.gray": "Sivi cvet",
  "block.minecraft.banner.flower.green": "Zeleni cvet",
  "block.minecraft.banner.flower.light_blue": "Svetloplavi cvet",
  "block.minecraft.banner.flower.light_gray": "Svetlosivi cvet",
  "block.minecraft.banner.flower.lime": "Svetlozeleni cvet",
  "block.minecraft.banner.flower.magenta": "Magenta cvet",
  "block.minecraft.banner.flower.orange": "Narandžasti cvet",
  "block.minecraft.banner.flower.pink": "Roze cvet",
  "block.minecraft.banner.flower.purple": "Ljubičasti cvet",
  "block.minecraft.banner.flower.red": "Crveni cvet",
  "block.minecraft.banner.flower.white": "Beli cvet",
  "block.minecraft.banner.flower.yellow": "Žuti cvet",
  "block.minecraft.banner.globe.black": "Crni globus",
  "block.minecraft.banner.globe.blue": "Plavi globus",
  "block.minecraft.banner.globe.brown": "Braon globus",
  "block.minecraft.banner.globe.cyan": "Tirkizni globus",
  "block.minecraft.banner.globe.gray": "Sivi globus",
  "block.minecraft.banner.globe.green": "Zeleni globus",
  "block.minecraft.banner.globe.light_blue": "Svetloplavi globus",
  "block.minecraft.banner.globe.light_gray": "Svetlosivi globus",
  "block.minecraft.banner.globe.lime": "Svetlozeleni globus",
  "block.minecraft.banner.globe.magenta": "Magenta globus",
  "block.minecraft.banner.globe.orange": "Narandžasti globus",
  "block.minecraft.banner.globe.pink": "Roze globus",
  "block.minecraft.banner.globe.purple": "Ljubičasti globus",
  "block.minecraft.banner.globe.red": "Crveni globus",
  "block.minecraft.banner.globe.white": "Beli globus",
  "block.minecraft.banner.globe.yellow": "Žuti globus",
  "block.minecraft.banner.gradient.black": "Crni gradijent",
  "block.minecraft.banner.gradient.blue": "Plavi gradijent",
  "block.minecraft.banner.gradient.brown": "Braon gradijent",
  "block.minecraft.banner.gradient.cyan": "Tirkizni gradijent",
  "block.minecraft.banner.gradient.gray": "Sivi gradijent",
  "block.minecraft.banner.gradient.green": "Zeleni gradijent",
  "block.minecraft.banner.gradient.light_blue": "Svetloplavi gradijent",
  "block.minecraft.banner.gradient.light_gray": "Svetlosivi gradijent",
  "block.minecraft.banner.gradient.lime": "Svetlozeleni gradijent",
  "block.minecraft.banner.gradient.magenta": "Magenta gradijent",
  "block.minecraft.banner.gradient.orange": "Narandžasti gradijent",
  "block.minecraft.banner.gradient.pink": "Roze gradijent",
  "block.minecraft.banner.gradient.purple": "Ljubičasti gradijent",
  "block.minecraft.banner.gradient.red": "Crveni gradijent",
  "block.minecraft.banner.gradient.white": "Beli gradijent",
  "block.minecraft.banner.gradient.yellow": "Žuti gradijent",
  "block.minecraft.banner.gradient_up.black": "Crni gradijent nagore",
  "block.minecraft.banner.gradient_up.blue": "Plavi gradijent nagore",
  "block.minecraft.banner.gradient_up.brown": "Braon gradijent nagore",
  "block.minecraft.banner.gradient_up.cyan": "Tirkizni gradijent nagore",
  "block.minecraft.banner.gradient_up.gray": "Sivi gradijent nagore",
  "block.minecraft.banner.gradient_up.green": "Zeleni gradijent nagore",
  "block.minecraft.banner.gradient_up.light_blue": "Svetloplavi gradijent nagore",
  "block.minecraft.banner.gradient_up.light_gray": "Svetlosivi gradijent nagore",
  "block.minecraft.banner.gradient_up.lime": "Svetlozeleni gradijent nagore",
  "block.minecraft.banner.gradient_up.magenta": "Magenta gradijent nagore",
  "block.minecraft.banner.gradient_up.orange": "Narandžasti gradijent nagore",
  "block.minecraft.banner.gradient_up.pink": "Roze gradijent nagore",
  "block.minecraft.banner.gradient_up.purple": "Ljubičasti gradijent nagore",
  "block.minecraft.banner.gradient_up.red": "Crveni gradijent nagore",
  "block.minecraft.banner.gradient_up.white": "Beli gradijent nagore",
  "block.minecraft.banner.gradient_up.yellow": "Žuti gradijent nagore",
  "block.minecraft.banner.guster.black": "Crni zapuh",
  "block.minecraft.banner.guster.blue": "Plavi zapuh",
  "block.minecraft.banner.guster.brown": "Braon zapuh",
  "block.minecraft.banner.guster.cyan": "Tirkizni zapuh",
  "block.minecraft.banner.guster.gray": "Sivi zapuh",
  "block.minecraft.banner.guster.green": "Zeleni zapuh",
  "block.minecraft.banner.guster.light_blue": "Svetloplavi zapuh",
  "block.minecraft.banner.guster.light_gray": "Svetlosivi zapuh",
  "block.minecraft.banner.guster.lime": "Svetlozeleni zapuh",
  "block.minecraft.banner.guster.magenta": "Magenta zapuh",
  "block.minecraft.banner.guster.orange": "Narandžasti zapuh",
  "block.minecraft.banner.guster.pink": "Roze zapuh",
  "block.minecraft.banner.guster.purple": "Ljubičasti zapuh",
  "block.minecraft.banner.guster.red": "Crveni zapuh",
  "block.minecraft.banner.guster.white": "Beli zapuh",
  "block.minecraft.banner.guster.yellow": "Žuti zapuh",
  "block.minecraft.banner.half_horizontal.black": "Crna gornja polovina",
  "block.minecraft.banner.half_horizontal.blue": "Plava gonja polovina",
  "block.minecraft.banner.half_horizontal.brown": "Braon gornja polovina",
  "block.minecraft.banner.half_horizontal.cyan": "Tirkizna gornja polovina",
  "block.minecraft.banner.half_horizontal.gray": "Siva gornja polovina",
  "block.minecraft.banner.half_horizontal.green": "Zelena gornja polovina",
  "block.minecraft.banner.half_horizontal.light_blue": "Svetloplava gornja polovina",
  "block.minecraft.banner.half_horizontal.light_gray": "Svetlosiva gornja polovina",
  "block.minecraft.banner.half_horizontal.lime": "Svetlozelena gornja polovina",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta gornja polovina",
  "block.minecraft.banner.half_horizontal.orange": "Narandžasta gornja polovina",
  "block.minecraft.banner.half_horizontal.pink": "Roze gornja polovina",
  "block.minecraft.banner.half_horizontal.purple": "Ljubičasta gornja polovina",
  "block.minecraft.banner.half_horizontal.red": "Crvena gornja polovina",
  "block.minecraft.banner.half_horizontal.white": "Bela gornja polovina",
  "block.minecraft.banner.half_horizontal.yellow": "Žuta gornja polovina",
  "block.minecraft.banner.half_horizontal_bottom.black": "Crna donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Plava donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Braon donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Tirkizna donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Siva donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zelena donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Svetloplava donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Svetlosiva donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Svetlozelena donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Narandžasta donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roze donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Ljubičasta donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.red": "Crvena donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.white": "Bela donja polovina",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Žuta donja polovina",
  "block.minecraft.banner.half_vertical.black": "Crna leva polovina",
  "block.minecraft.banner.half_vertical.blue": "Plava leva polovina",
  "block.minecraft.banner.half_vertical.brown": "Braon leva polovina",
  "block.minecraft.banner.half_vertical.cyan": "Tirkizna leva polovina",
  "block.minecraft.banner.half_vertical.gray": "Siva leva polovina",
  "block.minecraft.banner.half_vertical.green": "Zelena leva polovina",
  "block.minecraft.banner.half_vertical.light_blue": "Svetloplava leva polovina",
  "block.minecraft.banner.half_vertical.light_gray": "Svetlosiva leva polovina",
  "block.minecraft.banner.half_vertical.lime": "Svetlozelena leva polovina",
  "block.minecraft.banner.half_vertical.magenta": "Magenta leva polovina",
  "block.minecraft.banner.half_vertical.orange": "Narandžasta leva polovina",
  "block.minecraft.banner.half_vertical.pink": "Roze leva polovina",
  "block.minecraft.banner.half_vertical.purple": "Ljubičasta leva polovina",
  "block.minecraft.banner.half_vertical.red": "Crvena leva polovina",
  "block.minecraft.banner.half_vertical.white": "Bela leva polovina",
  "block.minecraft.banner.half_vertical.yellow": "Žuta leva polovina",
  "block.minecraft.banner.half_vertical_right.black": "Crna desna polovina",
  "block.minecraft.banner.half_vertical_right.blue": "Plava desna polovina",
  "block.minecraft.banner.half_vertical_right.brown": "Braon desna polovina",
  "block.minecraft.banner.half_vertical_right.cyan": "Tirkizna desna polovina",
  "block.minecraft.banner.half_vertical_right.gray": "Siva desna polovina",
  "block.minecraft.banner.half_vertical_right.green": "Zelena desna polovina",
  "block.minecraft.banner.half_vertical_right.light_blue": "Svetloplava desna polovina",
  "block.minecraft.banner.half_vertical_right.light_gray": "Svetlosiva desna polovina",
  "block.minecraft.banner.half_vertical_right.lime": "Svetlozelena desna polovina",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta desna polovina",
  "block.minecraft.banner.half_vertical_right.orange": "Narandžasta desna polovina",
  "block.minecraft.banner.half_vertical_right.pink": "Roze desna polovina",
  "block.minecraft.banner.half_vertical_right.purple": "Ljubičasta desna polovina",
  "block.minecraft.banner.half_vertical_right.red": "Crvena desna polovina",
  "block.minecraft.banner.half_vertical_right.white": "Bela desna polovina",
  "block.minecraft.banner.half_vertical_right.yellow": "Žuta desna polovina",
  "block.minecraft.banner.mojang.black": "Crna stvar",
  "block.minecraft.banner.mojang.blue": "Plava stvar",
  "block.minecraft.banner.mojang.brown": "Braon stvar",
  "block.minecraft.banner.mojang.cyan": "Tirkizna stvar",
  "block.minecraft.banner.mojang.gray": "Siva stvar",
  "block.minecraft.banner.mojang.green": "Zelena stvar",
  "block.minecraft.banner.mojang.light_blue": "Svetloplava stvar",
  "block.minecraft.banner.mojang.light_gray": "Svetlosiva stvar",
  "block.minecraft.banner.mojang.lime": "Svetlozelena stvar",
  "block.minecraft.banner.mojang.magenta": "Magenta stvar",
  "block.minecraft.banner.mojang.orange": "Narandžasta stvar",
  "block.minecraft.banner.mojang.pink": "Roze stvar",
  "block.minecraft.banner.mojang.purple": "Ljubičasta stvar",
  "block.minecraft.banner.mojang.red": "Crvena stvar",
  "block.minecraft.banner.mojang.white": "Bela stvar",
  "block.minecraft.banner.mojang.yellow": "Žuta stvar",
  "block.minecraft.banner.piglin.black": "Crna njuška",
  "block.minecraft.banner.piglin.blue": "Plava njuška",
  "block.minecraft.banner.piglin.brown": "Braon njuška",
  "block.minecraft.banner.piglin.cyan": "Tirkizna njuška",
  "block.minecraft.banner.piglin.gray": "Siva njuška",
  "block.minecraft.banner.piglin.green": "Zelena njuška",
  "block.minecraft.banner.piglin.light_blue": "Svetloplava njuška",
  "block.minecraft.banner.piglin.light_gray": "Svetlosiva njuška",
  "block.minecraft.banner.piglin.lime": "Svetlozelena njuška",
  "block.minecraft.banner.piglin.magenta": "Magenta njuška",
  "block.minecraft.banner.piglin.orange": "Narandžasta njuška",
  "block.minecraft.banner.piglin.pink": "Roze njuška",
  "block.minecraft.banner.piglin.purple": "Ljubičasta njuška",
  "block.minecraft.banner.piglin.red": "Crvena njuška",
  "block.minecraft.banner.piglin.white": "Bela njuška",
  "block.minecraft.banner.piglin.yellow": "Žuta njuška",
  "block.minecraft.banner.rhombus.black": "Crni romb",
  "block.minecraft.banner.rhombus.blue": "Plavi romb",
  "block.minecraft.banner.rhombus.brown": "Braon romb",
  "block.minecraft.banner.rhombus.cyan": "Tirkizni romb",
  "block.minecraft.banner.rhombus.gray": "Sivi romb",
  "block.minecraft.banner.rhombus.green": "Zeleni romb",
  "block.minecraft.banner.rhombus.light_blue": "Svetloplavi romb",
  "block.minecraft.banner.rhombus.light_gray": "Svetlosivi romb",
  "block.minecraft.banner.rhombus.lime": "Svetlozeleni romb",
  "block.minecraft.banner.rhombus.magenta": "Magenta romb",
  "block.minecraft.banner.rhombus.orange": "Narandžasti romb",
  "block.minecraft.banner.rhombus.pink": "Roze romb",
  "block.minecraft.banner.rhombus.purple": "Ljubičasti romb",
  "block.minecraft.banner.rhombus.red": "Crveni romb",
  "block.minecraft.banner.rhombus.white": "Beli romb",
  "block.minecraft.banner.rhombus.yellow": "Žuti romb",
  "block.minecraft.banner.skull.black": "Crna lobanja",
  "block.minecraft.banner.skull.blue": "Plava lobanja",
  "block.minecraft.banner.skull.brown": "Braon lobanja",
  "block.minecraft.banner.skull.cyan": "Tirkizna lobanja",
  "block.minecraft.banner.skull.gray": "Siva lobanja",
  "block.minecraft.banner.skull.green": "Zelena lobanja",
  "block.minecraft.banner.skull.light_blue": "Svetloplava lobanja",
  "block.minecraft.banner.skull.light_gray": "Svetlosiva lobanja",
  "block.minecraft.banner.skull.lime": "Svetlozelena lobanja",
  "block.minecraft.banner.skull.magenta": "Magenta lobanja",
  "block.minecraft.banner.skull.orange": "Narandžasta lobanja",
  "block.minecraft.banner.skull.pink": "Roze lobanja",
  "block.minecraft.banner.skull.purple": "Ljubičasta lobanja",
  "block.minecraft.banner.skull.red": "Crvena lobanja",
  "block.minecraft.banner.skull.white": "Bela lobanja",
  "block.minecraft.banner.skull.yellow": "Žuta lobanja",
  "block.minecraft.banner.small_stripes.black": "Crne rešetke",
  "block.minecraft.banner.small_stripes.blue": "Plave rešetke",
  "block.minecraft.banner.small_stripes.brown": "Braon rešetke",
  "block.minecraft.banner.small_stripes.cyan": "Tirkizne pruge",
  "block.minecraft.banner.small_stripes.gray": "Sive rešetke",
  "block.minecraft.banner.small_stripes.green": "Zelene rešetke",
  "block.minecraft.banner.small_stripes.light_blue": "Svetloplave rešetke",
  "block.minecraft.banner.small_stripes.light_gray": "Svetlosive rešetke",
  "block.minecraft.banner.small_stripes.lime": "Svetlozelene rešetke",
  "block.minecraft.banner.small_stripes.magenta": "Magenta rešetke",
  "block.minecraft.banner.small_stripes.orange": "Narandžaste pruge",
  "block.minecraft.banner.small_stripes.pink": "Roze rešetke",
  "block.minecraft.banner.small_stripes.purple": "Ljubičaste rešetke",
  "block.minecraft.banner.small_stripes.red": "Crvene rešetke",
  "block.minecraft.banner.small_stripes.white": "Bele pruge",
  "block.minecraft.banner.small_stripes.yellow": "Žute rešetke",
  "block.minecraft.banner.square_bottom_left.black": "Crni kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.blue": "Plavi kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.brown": "Braon kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.cyan": "Tirkizni kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.gray": "Sivi kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.green": "Zeleni kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.light_blue": "Svetloplavi kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.light_gray": "Svetlosivi kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.lime": "Svetlozeleni kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.orange": "Narandžasti kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.pink": "Pink kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.purple": "Ljubičasti kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.red": "Crveni kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.white": "Beli kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_left.yellow": "Žuti kvadrat u donjem levom uglu",
  "block.minecraft.banner.square_bottom_right.black": "Crni kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.blue": "Plavi kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.brown": "Braon kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.cyan": "Tirkizni kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.gray": "Sivi kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.green": "Zeleni kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.light_blue": "Svetloplavi kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.light_gray": "Svetlosivi kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.lime": "Svetlozeleni kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.orange": "Narandžasti kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.pink": "Pink kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.purple": "Ljubičasti kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.red": "Crveni kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.white": "Beli kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_bottom_right.yellow": "Žuti kvadrat u donjem desnom uglu",
  "block.minecraft.banner.square_top_left.black": "Crni kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.blue": "Plavi kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.brown": "Braon kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.cyan": "Tirkizni kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.gray": "Sivi kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.green": "Zeleni kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.light_blue": "Svetloplavi kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.light_gray": "Svetlosivi kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.lime": "Svetlozeleni kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.magenta": "Magenta kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.orange": "Narandžasti kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.pink": "Roze kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.purple": "Ljubičasti kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.red": "Crveni kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.white": "Beli kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_left.yellow": "Žuti kvadrat u gornjem levom uglu",
  "block.minecraft.banner.square_top_right.black": "Crni kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.blue": "Plavi kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.brown": "Braon kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.cyan": "Tirkizni kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.gray": "Sivi kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.green": "Zeleni kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.light_blue": "Svetloplavi kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.light_gray": "Svetlosivi kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.lime": "Svetlozeleni kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.magenta": "Magenta kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.orange": "Narandžasti kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.pink": "Roze kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.purple": "Ljubičasti kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.red": "Crveni kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.white": "Beli kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.square_top_right.yellow": "Žuti kvadrat u gornjem desnom uglu",
  "block.minecraft.banner.straight_cross.black": "Crni krst",
  "block.minecraft.banner.straight_cross.blue": "Plavi krst",
  "block.minecraft.banner.straight_cross.brown": "Braon krst",
  "block.minecraft.banner.straight_cross.cyan": "Tirkizni krst",
  "block.minecraft.banner.straight_cross.gray": "Sivi krst",
  "block.minecraft.banner.straight_cross.green": "Zeleni krst",
  "block.minecraft.banner.straight_cross.light_blue": "Svetloplavi krst",
  "block.minecraft.banner.straight_cross.light_gray": "Svetlosivi krst",
  "block.minecraft.banner.straight_cross.lime": "Svetlozeleni krst",
  "block.minecraft.banner.straight_cross.magenta": "Magenta krst",
  "block.minecraft.banner.straight_cross.orange": "Narandžasti krst",
  "block.minecraft.banner.straight_cross.pink": "Roze krst",
  "block.minecraft.banner.straight_cross.purple": "Ljubičasti krst",
  "block.minecraft.banner.straight_cross.red": "Crveni krst",
  "block.minecraft.banner.straight_cross.white": "Beli krst",
  "block.minecraft.banner.straight_cross.yellow": "Žuti krst",
  "block.minecraft.banner.stripe_bottom.black": "Crni donji deo",
  "block.minecraft.banner.stripe_bottom.blue": "Plavi donji deo",
  "block.minecraft.banner.stripe_bottom.brown": "Braon donji deo",
  "block.minecraft.banner.stripe_bottom.cyan": "Tirkizni donji deo",
  "block.minecraft.banner.stripe_bottom.gray": "Sivi donji deo",
  "block.minecraft.banner.stripe_bottom.green": "Zeleni donji deo",
  "block.minecraft.banner.stripe_bottom.light_blue": "Svetloplavi donji deo",
  "block.minecraft.banner.stripe_bottom.light_gray": "Svetlosivi donji deo",
  "block.minecraft.banner.stripe_bottom.lime": "Svetlozeleni donji deo",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta donji deo",
  "block.minecraft.banner.stripe_bottom.orange": "Narandžasti donji deo",
  "block.minecraft.banner.stripe_bottom.pink": "Roze donji deo",
  "block.minecraft.banner.stripe_bottom.purple": "Ljubičasti donji deo",
  "block.minecraft.banner.stripe_bottom.red": "Crveni donji deo",
  "block.minecraft.banner.stripe_bottom.white": "Beli donji deo",
  "block.minecraft.banner.stripe_bottom.yellow": "Žuti donji deo",
  "block.minecraft.banner.stripe_center.black": "Crna traka",
  "block.minecraft.banner.stripe_center.blue": "Plava traka",
  "block.minecraft.banner.stripe_center.brown": "Braon traka",
  "block.minecraft.banner.stripe_center.cyan": "Tirkizna traka",
  "block.minecraft.banner.stripe_center.gray": "Siva traka",
  "block.minecraft.banner.stripe_center.green": "Zelena traka",
  "block.minecraft.banner.stripe_center.light_blue": "Svetloplava traka",
  "block.minecraft.banner.stripe_center.light_gray": "Svetlosiva traka",
  "block.minecraft.banner.stripe_center.lime": "Svetlozelena traka",
  "block.minecraft.banner.stripe_center.magenta": "Magenta traka",
  "block.minecraft.banner.stripe_center.orange": "Narandžasta traka",
  "block.minecraft.banner.stripe_center.pink": "Roze traka",
  "block.minecraft.banner.stripe_center.purple": "Ljubičasta traka",
  "block.minecraft.banner.stripe_center.red": "Crvena traka",
  "block.minecraft.banner.stripe_center.white": "Bela traka",
  "block.minecraft.banner.stripe_center.yellow": "Žuta traka",
  "block.minecraft.banner.stripe_downleft.black": "Crna leva dijagonala",
  "block.minecraft.banner.stripe_downleft.blue": "Plava leva dijagonala",
  "block.minecraft.banner.stripe_downleft.brown": "Braon leva dijagonala",
  "block.minecraft.banner.stripe_downleft.cyan": "Tirkizna leva dijagonala",
  "block.minecraft.banner.stripe_downleft.gray": "Siva leva dijagonala",
  "block.minecraft.banner.stripe_downleft.green": "Zelena leva dijagonala",
  "block.minecraft.banner.stripe_downleft.light_blue": "Svetloplava leva dijagonala",
  "block.minecraft.banner.stripe_downleft.light_gray": "Svetlosiva leva dijagonala",
  "block.minecraft.banner.stripe_downleft.lime": "Svetlozelena leva dijagonala",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta leva dijagonala",
  "block.minecraft.banner.stripe_downleft.orange": "Narandžasta leva dijagonala",
  "block.minecraft.banner.stripe_downleft.pink": "Roze leva dijagonala",
  "block.minecraft.banner.stripe_downleft.purple": "Ljubičasta leva dijagonala",
  "block.minecraft.banner.stripe_downleft.red": "Crvena leva dijagonala",
  "block.minecraft.banner.stripe_downleft.white": "Bela leva dijagonala",
  "block.minecraft.banner.stripe_downleft.yellow": "Žuta leva dijagonala",
  "block.minecraft.banner.stripe_downright.black": "Crna desna dijagonala",
  "block.minecraft.banner.stripe_downright.blue": "Plava desna dijagonala",
  "block.minecraft.banner.stripe_downright.brown": "Braon desna dijagonala",
  "block.minecraft.banner.stripe_downright.cyan": "Tirkizna desna dijagonala",
  "block.minecraft.banner.stripe_downright.gray": "Siva desna dijagonala",
  "block.minecraft.banner.stripe_downright.green": "Zelena desna dijagonala",
  "block.minecraft.banner.stripe_downright.light_blue": "Svetloplava desna dijagonala",
  "block.minecraft.banner.stripe_downright.light_gray": "Svetlosiva desna dijagonala",
  "block.minecraft.banner.stripe_downright.lime": "Svetlozelena desna dijagonala",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta desna dijagonala",
  "block.minecraft.banner.stripe_downright.orange": "Narandžasta desna dijagonala",
  "block.minecraft.banner.stripe_downright.pink": "Roze desna dijagonala",
  "block.minecraft.banner.stripe_downright.purple": "Ljubičasta desna dijagonala",
  "block.minecraft.banner.stripe_downright.red": "Crvena desna dijagonala",
  "block.minecraft.banner.stripe_downright.white": "Bela desna dijagonala",
  "block.minecraft.banner.stripe_downright.yellow": "Žuta desna dijagonala",
  "block.minecraft.banner.stripe_left.black": "Crni levi stub",
  "block.minecraft.banner.stripe_left.blue": "Plavi levi stub",
  "block.minecraft.banner.stripe_left.brown": "Braon levi stub",
  "block.minecraft.banner.stripe_left.cyan": "Tirkizni levi stub",
  "block.minecraft.banner.stripe_left.gray": "Sivi levi stub",
  "block.minecraft.banner.stripe_left.green": "Zeleni levi stub",
  "block.minecraft.banner.stripe_left.light_blue": "Svetloplavi levi stub",
  "block.minecraft.banner.stripe_left.light_gray": "Svetlosivi levi stub",
  "block.minecraft.banner.stripe_left.lime": "Svetlozeleni levi stub",
  "block.minecraft.banner.stripe_left.magenta": "Magenta levi stub",
  "block.minecraft.banner.stripe_left.orange": "Narandžasti levi stub",
  "block.minecraft.banner.stripe_left.pink": "Roze levi stub",
  "block.minecraft.banner.stripe_left.purple": "Ljubičasti levi stub",
  "block.minecraft.banner.stripe_left.red": "Crveni levi stub",
  "block.minecraft.banner.stripe_left.white": "Beli levi stub",
  "block.minecraft.banner.stripe_left.yellow": "Žuti levi stub",
  "block.minecraft.banner.stripe_middle.black": "Crna srednja pruga",
  "block.minecraft.banner.stripe_middle.blue": "Plava srednja pruga",
  "block.minecraft.banner.stripe_middle.brown": "Braon srednja pruga",
  "block.minecraft.banner.stripe_middle.cyan": "Tirkizna srednja pruga",
  "block.minecraft.banner.stripe_middle.gray": "Siva srednja pruga",
  "block.minecraft.banner.stripe_middle.green": "Zelena srednja pruga",
  "block.minecraft.banner.stripe_middle.light_blue": "Svetloplava srednja pruga",
  "block.minecraft.banner.stripe_middle.light_gray": "Svetlosiva srednja pruga",
  "block.minecraft.banner.stripe_middle.lime": "Svetlozelena srednja pruga",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta srednja pruga",
  "block.minecraft.banner.stripe_middle.orange": "Narandžasta srednja pruga",
  "block.minecraft.banner.stripe_middle.pink": "Pink srednja pruga",
  "block.minecraft.banner.stripe_middle.purple": "Ljubičasta srednja pruga",
  "block.minecraft.banner.stripe_middle.red": "Crvena srednja pruga",
  "block.minecraft.banner.stripe_middle.white": "Bela srednja pruga",
  "block.minecraft.banner.stripe_middle.yellow": "Žuta srednja pruga",
  "block.minecraft.banner.stripe_right.black": "Crni desni stub",
  "block.minecraft.banner.stripe_right.blue": "Plavi desni stub",
  "block.minecraft.banner.stripe_right.brown": "Braon desni stub",
  "block.minecraft.banner.stripe_right.cyan": "Tirkizni desni stub",
  "block.minecraft.banner.stripe_right.gray": "Sivi desni stub",
  "block.minecraft.banner.stripe_right.green": "Zeleni desni stub",
  "block.minecraft.banner.stripe_right.light_blue": "Svetloplavi desni stub",
  "block.minecraft.banner.stripe_right.light_gray": "Svetlosivi desni stub",
  "block.minecraft.banner.stripe_right.lime": "Svetlozeleni desni stub",
  "block.minecraft.banner.stripe_right.magenta": "Magenta desni stub",
  "block.minecraft.banner.stripe_right.orange": "Narandžasti desni stub",
  "block.minecraft.banner.stripe_right.pink": "Pink desni stub",
  "block.minecraft.banner.stripe_right.purple": "Ljubičasti desni stub",
  "block.minecraft.banner.stripe_right.red": "Crveni desni stub",
  "block.minecraft.banner.stripe_right.white": "Beli desni stub",
  "block.minecraft.banner.stripe_right.yellow": "Žuti desni stub",
  "block.minecraft.banner.stripe_top.black": "Crn gornji deo",
  "block.minecraft.banner.stripe_top.blue": "Plavi gornji deo",
  "block.minecraft.banner.stripe_top.brown": "Braon gornji deo",
  "block.minecraft.banner.stripe_top.cyan": "Tirkizni gornji deo",
  "block.minecraft.banner.stripe_top.gray": "Sivi gornji deo",
  "block.minecraft.banner.stripe_top.green": "Zelen gornji deo",
  "block.minecraft.banner.stripe_top.light_blue": "Svetloplavi gornji deo",
  "block.minecraft.banner.stripe_top.light_gray": "Svetlosiv gornji deo",
  "block.minecraft.banner.stripe_top.lime": "Svetlozeleni gornji deo",
  "block.minecraft.banner.stripe_top.magenta": "Magenta gornji deo",
  "block.minecraft.banner.stripe_top.orange": "Narandžasti gornji deo",
  "block.minecraft.banner.stripe_top.pink": "Roze gornji deo",
  "block.minecraft.banner.stripe_top.purple": "Ljubičasti gornji deo",
  "block.minecraft.banner.stripe_top.red": "Crven gornji deo",
  "block.minecraft.banner.stripe_top.white": "Beli gornji deo",
  "block.minecraft.banner.stripe_top.yellow": "Žuti gornji deo",
  "block.minecraft.banner.triangle_bottom.black": "Crna piramida",
  "block.minecraft.banner.triangle_bottom.blue": "Plava piramida",
  "block.minecraft.banner.triangle_bottom.brown": "Braon piramida",
  "block.minecraft.banner.triangle_bottom.cyan": "Tirkizna piramida",
  "block.minecraft.banner.triangle_bottom.gray": "Siva piramida",
  "block.minecraft.banner.triangle_bottom.green": "Zelena piramida",
  "block.minecraft.banner.triangle_bottom.light_blue": "Svetloplava piramida",
  "block.minecraft.banner.triangle_bottom.light_gray": "Svetlosiva piramida",
  "block.minecraft.banner.triangle_bottom.lime": "Svetlozelena piramida",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta piramida",
  "block.minecraft.banner.triangle_bottom.orange": "Narandžasta piramida",
  "block.minecraft.banner.triangle_bottom.pink": "Roze piramida",
  "block.minecraft.banner.triangle_bottom.purple": "Ljubičasta piramida",
  "block.minecraft.banner.triangle_bottom.red": "Crvena piramida",
  "block.minecraft.banner.triangle_bottom.white": "Bela piramida",
  "block.minecraft.banner.triangle_bottom.yellow": "Žuta piramida",
  "block.minecraft.banner.triangle_top.black": "Crna obrnuta piramida",
  "block.minecraft.banner.triangle_top.blue": "Plava obrnuta piramida",
  "block.minecraft.banner.triangle_top.brown": "Braon obrnuta piramida",
  "block.minecraft.banner.triangle_top.cyan": "Obrnuta tirkizna piramida",
  "block.minecraft.banner.triangle_top.gray": "Siva obrnuta piramida",
  "block.minecraft.banner.triangle_top.green": "Zelena obrnuta piramida",
  "block.minecraft.banner.triangle_top.light_blue": "Svetloplava obrnuta piramida",
  "block.minecraft.banner.triangle_top.light_gray": "Svetlosiva obrnuta piramida",
  "block.minecraft.banner.triangle_top.lime": "Svetlozelena obrnuta piramida",
  "block.minecraft.banner.triangle_top.magenta": "Magenta obrnuta piramida",
  "block.minecraft.banner.triangle_top.orange": "Narandžasta obrnuta piramida",
  "block.minecraft.banner.triangle_top.pink": "Roze obrnuta piramida",
  "block.minecraft.banner.triangle_top.purple": "Ljubičasta obrnuta piramida",
  "block.minecraft.banner.triangle_top.red": "Crvena obrnuta piramida",
  "block.minecraft.banner.triangle_top.white": "Bela obrnuta piramida",
  "block.minecraft.banner.triangle_top.yellow": "Žuta piramida",
  "block.minecraft.banner.triangles_bottom.black": "Crni donji zubi",
  "block.minecraft.banner.triangles_bottom.blue": "Plavi donji zubi",
  "block.minecraft.banner.triangles_bottom.brown": "Braon donji zubi",
  "block.minecraft.banner.triangles_bottom.cyan": "Tirkizni donji zubi",
  "block.minecraft.banner.triangles_bottom.gray": "Sivi donji zubi",
  "block.minecraft.banner.triangles_bottom.green": "Zeleni donji zubi",
  "block.minecraft.banner.triangles_bottom.light_blue": "Svetloplavi donji zubi",
  "block.minecraft.banner.triangles_bottom.light_gray": "Svetlosivi donji zubi",
  "block.minecraft.banner.triangles_bottom.lime": "Svetlozeleni donji zubi",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta donji zubi",
  "block.minecraft.banner.triangles_bottom.orange": "Narandžasti donji zubi",
  "block.minecraft.banner.triangles_bottom.pink": "Roze donji zubi",
  "block.minecraft.banner.triangles_bottom.purple": "Ljubičasti donji zubi",
  "block.minecraft.banner.triangles_bottom.red": "Crveni donji zubi",
  "block.minecraft.banner.triangles_bottom.white": "Beli donji zubi",
  "block.minecraft.banner.triangles_bottom.yellow": "Žuti donji zubi",
  "block.minecraft.banner.triangles_top.black": "Crni gornji zubi",
  "block.minecraft.banner.triangles_top.blue": "Plavi gornji zubi",
  "block.minecraft.banner.triangles_top.brown": "Braon gornji zubi",
  "block.minecraft.banner.triangles_top.cyan": "Tirkizni gornji zubi",
  "block.minecraft.banner.triangles_top.gray": "Sivi gornji zubi",
  "block.minecraft.banner.triangles_top.green": "Zeleni gornji zubi",
  "block.minecraft.banner.triangles_top.light_blue": "Svetloplavi gornji zubi",
  "block.minecraft.banner.triangles_top.light_gray": "Svetlosivi gornji zubi",
  "block.minecraft.banner.triangles_top.lime": "Svetlozeleni gornji zubi",
  "block.minecraft.banner.triangles_top.magenta": "Magenta gornji zubi",
  "block.minecraft.banner.triangles_top.orange": "Narandžasti gornji zubi",
  "block.minecraft.banner.triangles_top.pink": "Roze gornji zubi",
  "block.minecraft.banner.triangles_top.purple": "Ljubičasti gornji zubi",
  "block.minecraft.banner.triangles_top.red": "Crveni gornji zubi",
  "block.minecraft.banner.triangles_top.white": "Beli gornji zubi",
  "block.minecraft.banner.triangles_top.yellow": "Žuti gornji zubi",
  "block.minecraft.barrel": "Bure",
  "block.minecraft.barrier": "Prepreka",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Svetionik",
  "block.minecraft.beacon.primary": "Primarni efekat",
  "block.minecraft.beacon.secondary": "Sekundarni efekat",
  "block.minecraft.bed.no_sleep": "Možete spavati samo noću ili tokom grmljavina",
  "block.minecraft.bed.not_safe": "Sada ne možeš da se odmaraš; čudovišta su u blizini",
  "block.minecraft.bed.obstructed": "Ovaj krevet je blokiran",
  "block.minecraft.bed.occupied": "Ovaj krevet je zauzet",
  "block.minecraft.bed.too_far_away": "Sada ne možeš da se odmaraš; krevet je predaleko",
  "block.minecraft.bedrock": "Temeljac",
  "block.minecraft.bee_nest": "Pčelino gnezdo",
  "block.minecraft.beehive": "Košnica",
  "block.minecraft.beetroots": "Cvekla",
  "block.minecraft.bell": "Zvono",
  "block.minecraft.big_dripleaf": "Veliki kap-list",
  "block.minecraft.big_dripleaf_stem": "Velika stabljika kap-lista",
  "block.minecraft.birch_button": "Brezovo dugme",
  "block.minecraft.birch_door": "Brezova vrata",
  "block.minecraft.birch_fence": "Brezova ograda",
  "block.minecraft.birch_fence_gate": "Brezova kapija",
  "block.minecraft.birch_hanging_sign": "Viseći brezov znak",
  "block.minecraft.birch_leaves": "Brezovo lišće",
  "block.minecraft.birch_log": "Brezov panj",
  "block.minecraft.birch_planks": "Brezove daske",
  "block.minecraft.birch_pressure_plate": "Brezova potisna ploča",
  "block.minecraft.birch_sapling": "Brezova mladica",
  "block.minecraft.birch_shelf": "Polica od Breze",
  "block.minecraft.birch_sign": "Brezov znak",
  "block.minecraft.birch_slab": "Brezova ploča",
  "block.minecraft.birch_stairs": "Brezove stepenice",
  "block.minecraft.birch_trapdoor": "Brezovo okno",
  "block.minecraft.birch_wall_hanging_sign": "Viseći zidni brezov znak",
  "block.minecraft.birch_wall_sign": "Brezov zidni znak",
  "block.minecraft.birch_wood": "Brezovina",
  "block.minecraft.black_banner": "Crna zastava",
  "block.minecraft.black_bed": "Crn krevet",
  "block.minecraft.black_candle": "Crna sveća",
  "block.minecraft.black_candle_cake": "Torta sa crnom svećom",
  "block.minecraft.black_carpet": "Crni tepih",
  "block.minecraft.black_concrete": "Crni beton",
  "block.minecraft.black_concrete_powder": "Crni beton u prahu",
  "block.minecraft.black_glazed_terracotta": "Terakota sa glazurom crne",
  "block.minecraft.black_shulker_box": "Crna Shulker kutija",
  "block.minecraft.black_stained_glass": "Crno obojeno staklo",
  "block.minecraft.black_stained_glass_pane": "Crna staklena ploča",
  "block.minecraft.black_terracotta": "Crna terakota",
  "block.minecraft.black_wool": "Crna vuna",
  "block.minecraft.blackstone": "Crna kaldrma",
  "block.minecraft.blackstone_slab": "Ploča od crne kaldrme",
  "block.minecraft.blackstone_stairs": "Stepenice od crne kaldrme",
  "block.minecraft.blackstone_wall": "Zid od crne kaldrme",
  "block.minecraft.blast_furnace": "Visoka pećnica",
  "block.minecraft.blue_banner": "Plava zastava",
  "block.minecraft.blue_bed": "Plav krevet",
  "block.minecraft.blue_candle": "Plava sveća",
  "block.minecraft.blue_candle_cake": "Torta sa plavom svećom",
  "block.minecraft.blue_carpet": "Plavi tepih",
  "block.minecraft.blue_concrete": "Plavi beton",
  "block.minecraft.blue_concrete_powder": "Plavi beton u prahu",
  "block.minecraft.blue_glazed_terracotta": "Terakota sa glazurom plave",
  "block.minecraft.blue_ice": "Plavi led",
  "block.minecraft.blue_orchid": "Plava orhideja",
  "block.minecraft.blue_shulker_box": "Tamno plava Shulker kutija",
  "block.minecraft.blue_stained_glass": "Plavo obojeno staklo",
  "block.minecraft.blue_stained_glass_pane": "Plava staklena ploča",
  "block.minecraft.blue_terracotta": "Plava terakota",
  "block.minecraft.blue_wool": "Plava vuna",
  "block.minecraft.bone_block": "Blok od kostiju",
  "block.minecraft.bookshelf": "Polica za knjige",
  "block.minecraft.brain_coral": "Naborani koral",
  "block.minecraft.brain_coral_block": "Blok naboranog korala",
  "block.minecraft.brain_coral_fan": "Naborana koralna lepeza",
  "block.minecraft.brain_coral_wall_fan": "Naborana koralna zidna lepeza",
  "block.minecraft.brewing_stand": "Samovar za napitke",
  "block.minecraft.brick_slab": "Ciglena ploča",
  "block.minecraft.brick_stairs": "Ciglene stepenice",
  "block.minecraft.brick_wall": "Cigleni zid",
  "block.minecraft.bricks": "Cigle",
  "block.minecraft.brown_banner": "Braon zastava",
  "block.minecraft.brown_bed": "Braon krevet",
  "block.minecraft.brown_candle": "Braon sveća",
  "block.minecraft.brown_candle_cake": "Torta sa braon svećom",
  "block.minecraft.brown_carpet": "Braon tepih",
  "block.minecraft.brown_concrete": "Braon beton",
  "block.minecraft.brown_concrete_powder": "Braon beton u prahu",
  "block.minecraft.brown_glazed_terracotta": "Terakota sa glazurom braon",
  "block.minecraft.brown_mushroom": "Braon pečurka",
  "block.minecraft.brown_mushroom_block": "Blok braon pečurke",
  "block.minecraft.brown_shulker_box": "Braon Shulker kutija",
  "block.minecraft.brown_stained_glass": "Vraon obojeno staklo",
  "block.minecraft.brown_stained_glass_pane": "Braon staklena ploča",
  "block.minecraft.brown_terracotta": "Braon terakota",
  "block.minecraft.brown_wool": "Braon vuna",
  "block.minecraft.bubble_column": "Kolona mehura",
  "block.minecraft.bubble_coral": "Mehurasti koral",
  "block.minecraft.bubble_coral_block": "Blok mehurastog korala",
  "block.minecraft.bubble_coral_fan": "Mehurasta koralna lepeza",
  "block.minecraft.bubble_coral_wall_fan": "Mehurasta koralna zidna lepeza",
  "block.minecraft.budding_amethyst": "Rastući ametist",
  "block.minecraft.bush": "Žbun",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktus cvet",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrisani skalk senzor",
  "block.minecraft.campfire": "Logorska vatra",
  "block.minecraft.candle": "Sveća",
  "block.minecraft.candle_cake": "Torta sa svećom",
  "block.minecraft.carrots": "Šargarepe",
  "block.minecraft.cartography_table": "Sto za kartografiju",
  "block.minecraft.carved_pumpkin": "Urezana bundeva",
  "block.minecraft.cauldron": "Kotao",
  "block.minecraft.cave_air": "Pećinski vazduh",
  "block.minecraft.cave_vines": "Pećinske lijane",
  "block.minecraft.cave_vines_plant": "Biljka pećinske lijane",
  "block.minecraft.chain": "Lanac",
  "block.minecraft.chain_command_block": "Vezni komandni blok",
  "block.minecraft.cherry_button": "Trešnjino dugme",
  "block.minecraft.cherry_door": "Trešnjina vrata",
  "block.minecraft.cherry_fence": "Trešnjina ograda",
  "block.minecraft.cherry_fence_gate": "Trešnjina kapija",
  "block.minecraft.cherry_hanging_sign": "Trešnjin viseći znak",
  "block.minecraft.cherry_leaves": "Trešnjino lišće",
  "block.minecraft.cherry_log": "Trešnjino drvo",
  "block.minecraft.cherry_planks": "Trešnjine daske",
  "block.minecraft.cherry_pressure_plate": "Trešnjina potisna ploča",
  "block.minecraft.cherry_sapling": "Trešnjina mladica",
  "block.minecraft.cherry_shelf": "Polica od trešnje",
  "block.minecraft.cherry_sign": "Trešnjin znak",
  "block.minecraft.cherry_slab": "Trešnjina ploča",
  "block.minecraft.cherry_stairs": "Trešnjine stepenice",
  "block.minecraft.cherry_trapdoor": "Trešnjino okno",
  "block.minecraft.cherry_wall_hanging_sign": "Trešnjin zidni viseći znak",
  "block.minecraft.cherry_wall_sign": "Trešnjin zidni znak",
  "block.minecraft.cherry_wood": "Trešnjino drvo",
  "block.minecraft.chest": "Kovčeg",
  "block.minecraft.chipped_anvil": "Okrnjen nakovanj",
  "block.minecraft.chiseled_bookshelf": "Isklesana polica za knjige",
  "block.minecraft.chiseled_copper": "Isklesan bakar",
  "block.minecraft.chiseled_deepslate": "Isklesan škriljac",
  "block.minecraft.chiseled_nether_bricks": "Isklesane Nether cigle",
  "block.minecraft.chiseled_polished_blackstone": "Isklesana uglačana crna kaldrma",
  "block.minecraft.chiseled_quartz_block": "Isklesani kvarc",
  "block.minecraft.chiseled_red_sandstone": "Isklesani crveni peščar",
  "block.minecraft.chiseled_resin_bricks": "Isklesane cigle smole",
  "block.minecraft.chiseled_sandstone": "Isklesani peščar",
  "block.minecraft.chiseled_stone_bricks": "Isklesane kamene cigle",
  "block.minecraft.chiseled_tuff": "Isklesan Tuf",
  "block.minecraft.chiseled_tuff_bricks": "Isklesane Tuf Cigle",
  "block.minecraft.chorus_flower": "Horus cvet",
  "block.minecraft.chorus_plant": "Horus",
  "block.minecraft.clay": "Glina",
  "block.minecraft.closed_eyeblossom": "Zatvoren cvet očiju",
  "block.minecraft.coal_block": "Blok uglja",
  "block.minecraft.coal_ore": "Ruda uglja",
  "block.minecraft.coarse_dirt": "Hrapava zemlja",
  "block.minecraft.cobbled_deepslate": "Kaldrmisan škriljac",
  "block.minecraft.cobbled_deepslate_slab": "Ploča kaldrmisanog škriljca",
  "block.minecraft.cobbled_deepslate_stairs": "Stepenice kaldrmisanog škriljca",
  "block.minecraft.cobbled_deepslate_wall": "Zid od kaldrmisanog škriljca",
  "block.minecraft.cobblestone": "Kaldrma",
  "block.minecraft.cobblestone_slab": "Ploča od kaldrme",
  "block.minecraft.cobblestone_stairs": "Stepenice od kaldrme",
  "block.minecraft.cobblestone_wall": "Zid od kaldrme",
  "block.minecraft.cobweb": "Paučina",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Komandni blok",
  "block.minecraft.comparator": "Redstone komparator",
  "block.minecraft.composter": "Komposter",
  "block.minecraft.conduit": "Cevovod",
  "block.minecraft.copper_bars": "Bakarne Šipke",
  "block.minecraft.copper_block": "Blok bakra",
  "block.minecraft.copper_bulb": "Bakarna sijalica",
  "block.minecraft.copper_chain": "Lanac od Bakra",
  "block.minecraft.copper_chest": "Bakarni Kovčeg",
  "block.minecraft.copper_door": "Bakrena vrata",
  "block.minecraft.copper_golem_statue": "Statua od Bakarnog Golema",
  "block.minecraft.copper_grate": "Bakrena rešetka",
  "block.minecraft.copper_lantern": "Fenjer od Bakra",
  "block.minecraft.copper_ore": "Ruda bakra",
  "block.minecraft.copper_torch": "Baklja od Bakra",
  "block.minecraft.copper_trapdoor": "Bakarno okno",
  "block.minecraft.copper_wall_torch": "Zidna Baklja od Bakra",
  "block.minecraft.cornflower": "Različak",
  "block.minecraft.cracked_deepslate_bricks": "Napukle škriljaste cigle",
  "block.minecraft.cracked_deepslate_tiles": "Napukle škriljaste pločice",
  "block.minecraft.cracked_nether_bricks": "Napukle Nether cigle",
  "block.minecraft.cracked_polished_blackstone_bricks": "Napukle uglačane cigle od crne kaldrme",
  "block.minecraft.cracked_stone_bricks": "Napukle kamene cigle",
  "block.minecraft.crafter": "Proizvođač",
  "block.minecraft.crafting_table": "Zanatski sto",
  "block.minecraft.creaking_heart": "Srce Škripanja",
  "block.minecraft.creeper_head": "Creeper glava",
  "block.minecraft.creeper_wall_head": "Zidna Creeper glava",
  "block.minecraft.crimson_button": "Grimizno dugme",
  "block.minecraft.crimson_door": "Grimizna vrata",
  "block.minecraft.crimson_fence": "Grimizna ograda",
  "block.minecraft.crimson_fence_gate": "Grimizna kapija",
  "block.minecraft.crimson_fungus": "Grimizna gljiva",
  "block.minecraft.crimson_hanging_sign": "Grimizni viseći znak",
  "block.minecraft.crimson_hyphae": "Grimizna hifa",
  "block.minecraft.crimson_nylium": "Grimizni nilijum",
  "block.minecraft.crimson_planks": "Grimizne daske",
  "block.minecraft.crimson_pressure_plate": "Grimizna potisna ploča",
  "block.minecraft.crimson_roots": "Grimizno korenje",
  "block.minecraft.crimson_shelf": "Grimizna Polica",
  "block.minecraft.crimson_sign": "Grimizni znak",
  "block.minecraft.crimson_slab": "Grimizna ploča",
  "block.minecraft.crimson_stairs": "Grimizne stepenice",
  "block.minecraft.crimson_stem": "Grimizna stabljika",
  "block.minecraft.crimson_trapdoor": "Grimizno okno",
  "block.minecraft.crimson_wall_hanging_sign": "Grimizni viseći zidni znak",
  "block.minecraft.crimson_wall_sign": "Grimizni zidni znak",
  "block.minecraft.crying_obsidian": "Plačući obsidijan",
  "block.minecraft.cut_copper": "Sečeni bakar",
  "block.minecraft.cut_copper_slab": "Ploča sečenog bakra",
  "block.minecraft.cut_copper_stairs": "Sečene stepenice od bakra",
  "block.minecraft.cut_red_sandstone": "Sečeni crveni peščar",
  "block.minecraft.cut_red_sandstone_slab": "Ploča crvenog sečenog peščara",
  "block.minecraft.cut_sandstone": "Sečeni peščar",
  "block.minecraft.cut_sandstone_slab": "Ploča sečenog peščara",
  "block.minecraft.cyan_banner": "Tirkizna zastava",
  "block.minecraft.cyan_bed": "Tirkizni krevet",
  "block.minecraft.cyan_candle": "Tirkizna sveća",
  "block.minecraft.cyan_candle_cake": "Torta sa tirkiznom svećom",
  "block.minecraft.cyan_carpet": "Tirkizni tepih",
  "block.minecraft.cyan_concrete": "Tirkizni beton",
  "block.minecraft.cyan_concrete_powder": "Tirkizni beton u prahu",
  "block.minecraft.cyan_glazed_terracotta": "Terakota sa tirkiznom glazurom",
  "block.minecraft.cyan_shulker_box": "Tirkizna Shulker kutija",
  "block.minecraft.cyan_stained_glass": "Tirkizno obojeno staklo",
  "block.minecraft.cyan_stained_glass_pane": "Tirkizna staklena ploča",
  "block.minecraft.cyan_terracotta": "Tirkizna terakota",
  "block.minecraft.cyan_wool": "Tirkizna vuna",
  "block.minecraft.damaged_anvil": "Oštećen nakovanj",
  "block.minecraft.dandelion": "Maslačak",
  "block.minecraft.dark_oak_button": "Tamno hrastovo dugme",
  "block.minecraft.dark_oak_door": "Tamna hrastova vrata",
  "block.minecraft.dark_oak_fence": "Tamna hrastova ograda",
  "block.minecraft.dark_oak_fence_gate": "Tamna hrastova kapija",
  "block.minecraft.dark_oak_hanging_sign": "Tamni hrastov viseći znak",
  "block.minecraft.dark_oak_leaves": "Tamno hrastovo lišće",
  "block.minecraft.dark_oak_log": "Tamni hrastov panj",
  "block.minecraft.dark_oak_planks": "Tamne hrastove daske",
  "block.minecraft.dark_oak_pressure_plate": "Tamno hrastova potisna ploča",
  "block.minecraft.dark_oak_sapling": "Mladica tamnog hrasta",
  "block.minecraft.dark_oak_shelf": "Tamha hrastova polica",
  "block.minecraft.dark_oak_sign": "Tamni hrastov znak",
  "block.minecraft.dark_oak_slab": "Tamna hrastova ploča",
  "block.minecraft.dark_oak_stairs": "Tamne hrastove stepenice",
  "block.minecraft.dark_oak_trapdoor": "Tamno hrastovo okno",
  "block.minecraft.dark_oak_wall_hanging_sign": "Mračni hrastov zidni viseći znak",
  "block.minecraft.dark_oak_wall_sign": "Tamni hrastov zidni znak",
  "block.minecraft.dark_oak_wood": "Tamna hrastovina",
  "block.minecraft.dark_prismarine": "Tamni prizmarin",
  "block.minecraft.dark_prismarine_slab": "Tamna ploča prizmarina",
  "block.minecraft.dark_prismarine_stairs": "Tamne stepenice prizmarina",
  "block.minecraft.daylight_detector": "Senzor za sunčevu svetlost",
  "block.minecraft.dead_brain_coral": "Mrtvi Naborani koral",
  "block.minecraft.dead_brain_coral_block": "Blok mrtvog naboranog korala",
  "block.minecraft.dead_brain_coral_fan": "Mrtva naborana koralna lepeza",
  "block.minecraft.dead_brain_coral_wall_fan": "Mrtva naborana koralna zidna lepeza",
  "block.minecraft.dead_bubble_coral": "Mrtvi mehurasti Koral",
  "block.minecraft.dead_bubble_coral_block": "Blok mrtvog mehurastog korala",
  "block.minecraft.dead_bubble_coral_fan": "Mrtva mehurasta koralna lepeza",
  "block.minecraft.dead_bubble_coral_wall_fan": "Mrtva mehurasta koralna zidna lepeza",
  "block.minecraft.dead_bush": "Uvenuli žbun",
  "block.minecraft.dead_fire_coral": "Mrtvi Vatreni Koral",
  "block.minecraft.dead_fire_coral_block": "Blok mrtvog vatrenog korala",
  "block.minecraft.dead_fire_coral_fan": "Mrtva vatrena koralna lepeza",
  "block.minecraft.dead_fire_coral_wall_fan": "Mrtva vatrena koralna zidna lepeza",
  "block.minecraft.dead_horn_coral": "Mrtvi Rogasti Koral",
  "block.minecraft.dead_horn_coral_block": "Blok mrtvog rogastog korala",
  "block.minecraft.dead_horn_coral_fan": "Mrtva rogasta koralna lepeza",
  "block.minecraft.dead_horn_coral_wall_fan": "Mrtva rogasta koralna zidna lepeza",
  "block.minecraft.dead_tube_coral": "Mrtvi cevasti koral",
  "block.minecraft.dead_tube_coral_block": "Blok mrtvog cevastog korala",
  "block.minecraft.dead_tube_coral_fan": "Mrtva cevasta koralna lepeza",
  "block.minecraft.dead_tube_coral_wall_fan": "Mrtva cevasta koralna zidna lepeza",
  "block.minecraft.decorated_pot": "Ukrašeni ćup",
  "block.minecraft.deepslate": "Škriljac",
  "block.minecraft.deepslate_brick_slab": "Ploča od škriljastih cigli",
  "block.minecraft.deepslate_brick_stairs": "Stepenice od škriljastih cigli",
  "block.minecraft.deepslate_brick_wall": "Zid od škriljastih cigli",
  "block.minecraft.deepslate_bricks": "Škriljaste cigle",
  "block.minecraft.deepslate_coal_ore": "Škriljasta ruda uglja",
  "block.minecraft.deepslate_copper_ore": "Škriljasta ruda bakra",
  "block.minecraft.deepslate_diamond_ore": "Škriljasta ruda dijamanta",
  "block.minecraft.deepslate_emerald_ore": "Škriljasta ruda smaragda",
  "block.minecraft.deepslate_gold_ore": "Škriljasta ruda zlata",
  "block.minecraft.deepslate_iron_ore": "Škriljasta ruda gvožđa",
  "block.minecraft.deepslate_lapis_ore": "Škriljasta ruda lapis lazulija",
  "block.minecraft.deepslate_redstone_ore": "Škriljasta redstone ruda",
  "block.minecraft.deepslate_tile_slab": "Ploča od škriljastih pločica",
  "block.minecraft.deepslate_tile_stairs": "Stepenice od škriljastih pločica",
  "block.minecraft.deepslate_tile_wall": "Zid od škriljastih pločica",
  "block.minecraft.deepslate_tiles": "Škriljaste pločice",
  "block.minecraft.detector_rail": "Pruga sa senzorom",
  "block.minecraft.diamond_block": "Dijamantski blok",
  "block.minecraft.diamond_ore": "Ruda dijamanta",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Ploča od diorita",
  "block.minecraft.diorite_stairs": "Stepenice od diorita",
  "block.minecraft.diorite_wall": "Zid od diorita",
  "block.minecraft.dirt": "Zemlja",
  "block.minecraft.dirt_path": "Zemljani put",
  "block.minecraft.dispenser": "Automat",
  "block.minecraft.dragon_egg": "Zmajevo jaje",
  "block.minecraft.dragon_head": "Zmajeva glava",
  "block.minecraft.dragon_wall_head": "Zidna Zmajeva glava",
  "block.minecraft.dried_ghast": "Osušeni Ghast",
  "block.minecraft.dried_kelp_block": "Osušeni blok morskih algi",
  "block.minecraft.dripstone_block": "Blok kapmena",
  "block.minecraft.dropper": "Izbacivač",
  "block.minecraft.emerald_block": "Blok smaragda",
  "block.minecraft.emerald_ore": "Ruda smaragda",
  "block.minecraft.enchanting_table": "Sto za čaranje",
  "block.minecraft.end_gateway": "End kapija",
  "block.minecraft.end_portal": "End portal",
  "block.minecraft.end_portal_frame": "Ram od End portala",
  "block.minecraft.end_rod": "End štap",
  "block.minecraft.end_stone": "End kamen",
  "block.minecraft.end_stone_brick_slab": "Ploča od kamenih End cigli",
  "block.minecraft.end_stone_brick_stairs": "Stepenice od kamenih End cigli",
  "block.minecraft.end_stone_brick_wall": "Zid od kamenih End cigli",
  "block.minecraft.end_stone_bricks": "End kamene cigle",
  "block.minecraft.ender_chest": "Ender kovčeg",
  "block.minecraft.exposed_chiseled_copper": "Izloženi Isklesani Bakar",
  "block.minecraft.exposed_copper": "Izloženi bakar",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Izložena bakarna sijalica",
  "block.minecraft.exposed_copper_chain": "Lanac of izloženog bakra",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Vrata od Izloženog Bakra",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Rešetka od Izloženog Bakra",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Okno od izloženog bakra",
  "block.minecraft.exposed_cut_copper": "Izloženi sečeni bakar",
  "block.minecraft.exposed_cut_copper_slab": "Izložena ploča od sečenog bakra",
  "block.minecraft.exposed_cut_copper_stairs": "Izložene stepenice od sečenog bakra",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Oranica",
  "block.minecraft.fern": "Paprat",
  "block.minecraft.fire": "Vatra",
  "block.minecraft.fire_coral": "Vatreni koral",
  "block.minecraft.fire_coral_block": "Vatreni koralni blok",
  "block.minecraft.fire_coral_fan": "Vatrena koralna lepeza",
  "block.minecraft.fire_coral_wall_fan": "Vatrena koralna zidna lepeza",
  "block.minecraft.firefly_bush": "Žbun svitaca",
  "block.minecraft.fletching_table": "Streljaški sto",
  "block.minecraft.flower_pot": "Saksija",
  "block.minecraft.flowering_azalea": "Cvetajuća azaleja",
  "block.minecraft.flowering_azalea_leaves": "Lišće cvetajuće azaleje",
  "block.minecraft.frogspawn": "Žablji mrest",
  "block.minecraft.frosted_ice": "Smrznuti led",
  "block.minecraft.furnace": "Pećnica",
  "block.minecraft.gilded_blackstone": "Pozlaćena crna kaldrma",
  "block.minecraft.glass": "Staklo",
  "block.minecraft.glass_pane": "Staklena ploča",
  "block.minecraft.glow_lichen": "Svetleći lišajevi",
  "block.minecraft.glowstone": "Žarkamen",
  "block.minecraft.gold_block": "Zlatni blok",
  "block.minecraft.gold_ore": "Ruda zlata",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Ploča od granita",
  "block.minecraft.granite_stairs": "Stepenice od granita",
  "block.minecraft.granite_wall": "Zid od granita",
  "block.minecraft.grass": "Trava",
  "block.minecraft.grass_block": "Blok trave",
  "block.minecraft.gravel": "Šljunak",
  "block.minecraft.gray_banner": "Siva zastava",
  "block.minecraft.gray_bed": "Siv krevet",
  "block.minecraft.gray_candle": "Siva sveća",
  "block.minecraft.gray_candle_cake": "Torta sa sivom svećom",
  "block.minecraft.gray_carpet": "Sivi tepih",
  "block.minecraft.gray_concrete": "Sivi beton",
  "block.minecraft.gray_concrete_powder": "Sivi beton u prahu",
  "block.minecraft.gray_glazed_terracotta": "Terakota sa glazurom sive",
  "block.minecraft.gray_shulker_box": "Siva Shulker kutija",
  "block.minecraft.gray_stained_glass": "Sivo obojeno staklo",
  "block.minecraft.gray_stained_glass_pane": "Siva staklena ploča",
  "block.minecraft.gray_terracotta": "Siva terakota",
  "block.minecraft.gray_wool": "Siva vuna",
  "block.minecraft.green_banner": "Zelena zastava",
  "block.minecraft.green_bed": "Zelen krevet",
  "block.minecraft.green_candle": "Zelena sveća",
  "block.minecraft.green_candle_cake": "Torta sa zelenom svećom",
  "block.minecraft.green_carpet": "Zeleni tepih",
  "block.minecraft.green_concrete": "Zeleni beton",
  "block.minecraft.green_concrete_powder": "Zeleni beton u prahu",
  "block.minecraft.green_glazed_terracotta": "Terakota sa glazurom zelene",
  "block.minecraft.green_shulker_box": "Zelena Shulker kutija",
  "block.minecraft.green_stained_glass": "Zeleno obojeno staklo",
  "block.minecraft.green_stained_glass_pane": "Zelena staklena ploča",
  "block.minecraft.green_terracotta": "Zelena terakota",
  "block.minecraft.green_wool": "Zelena vuna",
  "block.minecraft.grindstone": "Mlinski kamen",
  "block.minecraft.hanging_roots": "Viseće korenje",
  "block.minecraft.hay_block": "Bala sena",
  "block.minecraft.heavy_core": "Teško Jezgro",
  "block.minecraft.heavy_weighted_pressure_plate": "Teška potisna ploča",
  "block.minecraft.honey_block": "Blok meda",
  "block.minecraft.honeycomb_block": "Blok saća",
  "block.minecraft.hopper": "Levak",
  "block.minecraft.horn_coral": "Rogasti koral",
  "block.minecraft.horn_coral_block": "Rogasti koralni blok",
  "block.minecraft.horn_coral_fan": "Rogasta koralna lepeza",
  "block.minecraft.horn_coral_wall_fan": "Rogasta koralna zidna lepeza",
  "block.minecraft.ice": "Led",
  "block.minecraft.infested_chiseled_stone_bricks": "Zaražene isklesane kamene cigle",
  "block.minecraft.infested_cobblestone": "Zaražena kaldrma",
  "block.minecraft.infested_cracked_stone_bricks": "Zaražene napukle kamene cigle",
  "block.minecraft.infested_deepslate": "Zaražen škriljac",
  "block.minecraft.infested_mossy_stone_bricks": "Zaražene kamene cigle prekrivene mahovinom",
  "block.minecraft.infested_stone": "Zaraženi kamen",
  "block.minecraft.infested_stone_bricks": "Zaražene kamene cigle",
  "block.minecraft.iron_bars": "Gvozdene rešetke",
  "block.minecraft.iron_block": "Gvozdeni blok",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Gvozdena vrata",
  "block.minecraft.iron_ore": "Ruda gvožđa",
  "block.minecraft.iron_trapdoor": "Gvozdeno okno",
  "block.minecraft.jack_o_lantern": "Svetleća bundeva",
  "block.minecraft.jigsaw": "Blok slagalica",
  "block.minecraft.jukebox": "Džuboks",
  "block.minecraft.jungle_button": "Dugme od prašumskog drveta",
  "block.minecraft.jungle_door": "Vrata od prašumskog drveta",
  "block.minecraft.jungle_fence": "Ograda od prašumskog drveta",
  "block.minecraft.jungle_fence_gate": "Kapija od prašumskog drveta",
  "block.minecraft.jungle_hanging_sign": "Viseći znak od drveta iz džungle",
  "block.minecraft.jungle_leaves": "Prašumsko lišće",
  "block.minecraft.jungle_log": "Prašumsko drvo",
  "block.minecraft.jungle_planks": "Daske od prašumskog drveta",
  "block.minecraft.jungle_pressure_plate": "Potisna ploča od prašumskog drveta",
  "block.minecraft.jungle_sapling": "Mladica prašumskog drveta",
  "block.minecraft.jungle_shelf": "Jungle polica",
  "block.minecraft.jungle_sign": "Znak od prašumskog drveta",
  "block.minecraft.jungle_slab": "Ploča od prašumskog drveta",
  "block.minecraft.jungle_stairs": "Stepenice od prašumskog drveta",
  "block.minecraft.jungle_trapdoor": "Okno od prašumskog drveta",
  "block.minecraft.jungle_wall_hanging_sign": "Viseći zidni znak od drveta džungle",
  "block.minecraft.jungle_wall_sign": "Znak od prašumskog drveta",
  "block.minecraft.jungle_wood": "Prašumsko drvo",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Morske alge",
  "block.minecraft.ladder": "Merdevine",
  "block.minecraft.lantern": "Fenjer",
  "block.minecraft.lapis_block": "Blok lapis lazulija",
  "block.minecraft.lapis_ore": "Ruda lapis lazulija",
  "block.minecraft.large_amethyst_bud": "Veliki pupoljak ametista",
  "block.minecraft.large_fern": "Veliki paprat",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Kotao lave",
  "block.minecraft.leaf_litter": "Gomila Lišća",
  "block.minecraft.lectern": "Naslon za čitanje",
  "block.minecraft.lever": "Poluga",
  "block.minecraft.light": "Svetlo",
  "block.minecraft.light_blue_banner": "Svetloplava zastava",
  "block.minecraft.light_blue_bed": "Svetloplav krevet",
  "block.minecraft.light_blue_candle": "Svetloplava sveća",
  "block.minecraft.light_blue_candle_cake": "Torta sa svetlo plavom svećom",
  "block.minecraft.light_blue_carpet": "Svetloplavi tepih",
  "block.minecraft.light_blue_concrete": "Svetloplavi beton",
  "block.minecraft.light_blue_concrete_powder": "Svetloplavi beton u prahu",
  "block.minecraft.light_blue_glazed_terracotta": "Terakota sa glazurom svetlo bele",
  "block.minecraft.light_blue_shulker_box": "Svetloplava Shulker kutija",
  "block.minecraft.light_blue_stained_glass": "Svetloplavo obojeno staklo",
  "block.minecraft.light_blue_stained_glass_pane": "Svetloplava staklena ploča",
  "block.minecraft.light_blue_terracotta": "Svetloplava terakota",
  "block.minecraft.light_blue_wool": "Svetloplava vuna",
  "block.minecraft.light_gray_banner": "Svetlosiva zastava",
  "block.minecraft.light_gray_bed": "Svetlosiv krevet",
  "block.minecraft.light_gray_candle": "Svetlosiva sveća",
  "block.minecraft.light_gray_candle_cake": "Torta sa svetlosivom svećom",
  "block.minecraft.light_gray_carpet": "Svetlosivi tepih",
  "block.minecraft.light_gray_concrete": "Svetlosivi beton",
  "block.minecraft.light_gray_concrete_powder": "Svetlosivi beton u prahu",
  "block.minecraft.light_gray_glazed_terracotta": "Terakota sa glazurom svetlo sive",
  "block.minecraft.light_gray_shulker_box": "Svetlosiva Shulker kutija",
  "block.minecraft.light_gray_stained_glass": "Svetlosivo obojeno staklo",
  "block.minecraft.light_gray_stained_glass_pane": "Svetlosiva staklena ploča",
  "block.minecraft.light_gray_terracotta": "Svetlosiva terakota",
  "block.minecraft.light_gray_wool": "Svetlosiva vuna",
  "block.minecraft.light_weighted_pressure_plate": "Laka potisna ploča",
  "block.minecraft.lightning_rod": "Gromobran",
  "block.minecraft.lilac": "Jorgovan",
  "block.minecraft.lily_of_the_valley": "Đurđevak",
  "block.minecraft.lily_pad": "Lokvanj",
  "block.minecraft.lime_banner": "Svetlozelena zastava",
  "block.minecraft.lime_bed": "Svetlozelen krevet",
  "block.minecraft.lime_candle": "Svetlozelena sveća",
  "block.minecraft.lime_candle_cake": "Torta sa svetlozelenom svećom",
  "block.minecraft.lime_carpet": "Svetlozeleni tepih",
  "block.minecraft.lime_concrete": "Svetlozeleni beton",
  "block.minecraft.lime_concrete_powder": "Svetlozeleni beton u prahu",
  "block.minecraft.lime_glazed_terracotta": "Terakota sa glazurom svetlo zelene",
  "block.minecraft.lime_shulker_box": "Svetlozelena Shulker kutija",
  "block.minecraft.lime_stained_glass": "Svetlozeleno obojeno staklo",
  "block.minecraft.lime_stained_glass_pane": "Svetlozelena staklena ploča",
  "block.minecraft.lime_terracotta": "Svetlozelena terakota",
  "block.minecraft.lime_wool": "Svetlozelena vuna",
  "block.minecraft.lodestone": "Magnetit",
  "block.minecraft.loom": "Razboj",
  "block.minecraft.magenta_banner": "Magenta zastava",
  "block.minecraft.magenta_bed": "Magenta krevet",
  "block.minecraft.magenta_candle": "Magenta sveća",
  "block.minecraft.magenta_candle_cake": "Torta sa magenta svećom",
  "block.minecraft.magenta_carpet": "Magenta tepih",
  "block.minecraft.magenta_concrete": "Magenta beton",
  "block.minecraft.magenta_concrete_powder": "Magenta beton u prahu",
  "block.minecraft.magenta_glazed_terracotta": "Terakota sa magenta glazurom",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker kutija",
  "block.minecraft.magenta_stained_glass": "Magenta obojeno staklo",
  "block.minecraft.magenta_stained_glass_pane": "Magenta staklena ploča",
  "block.minecraft.magenta_terracotta": "Magenta terakota",
  "block.minecraft.magenta_wool": "Magenta vuna",
  "block.minecraft.magma_block": "Blok magme",
  "block.minecraft.mangrove_button": "Dugme od mangrova",
  "block.minecraft.mangrove_door": "Vrata od mangrova",
  "block.minecraft.mangrove_fence": "Ograda od mangrova",
  "block.minecraft.mangrove_fence_gate": "Kapija od mangrova",
  "block.minecraft.mangrove_hanging_sign": "Mangrovin viseći znak",
  "block.minecraft.mangrove_leaves": "Listovi mangrova",
  "block.minecraft.mangrove_log": "Mangrova",
  "block.minecraft.mangrove_planks": "Daske od mangrova",
  "block.minecraft.mangrove_pressure_plate": "Potisna ploča od mangrova",
  "block.minecraft.mangrove_propagule": "Propagula mangrova",
  "block.minecraft.mangrove_roots": "Korenje mangrova",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Znak od mangrova",
  "block.minecraft.mangrove_slab": "Ploča mangrova",
  "block.minecraft.mangrove_stairs": "Stepenice od mangrova",
  "block.minecraft.mangrove_trapdoor": "Okno od mangrova",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovin zidni viseći znak",
  "block.minecraft.mangrove_wall_sign": "Zidni znak od mangrova",
  "block.minecraft.mangrove_wood": "Drvo mangrova",
  "block.minecraft.medium_amethyst_bud": "Srednji pupoljak ametista",
  "block.minecraft.melon": "Lubenica",
  "block.minecraft.melon_stem": "Stabljika lubenice",
  "block.minecraft.moss_block": "Blok mahovine",
  "block.minecraft.moss_carpet": "Tepih od mahovine",
  "block.minecraft.mossy_cobblestone": "Kaldrma sa mahovinom",
  "block.minecraft.mossy_cobblestone_slab": "Ploča od kamena sa mahovinom",
  "block.minecraft.mossy_cobblestone_stairs": "Stepenice od kamenja sa mahovinom",
  "block.minecraft.mossy_cobblestone_wall": "Zid od kaldrme sa mahovinom",
  "block.minecraft.mossy_stone_brick_slab": "Ploča od kamenja sa mahovinom",
  "block.minecraft.mossy_stone_brick_stairs": "Stepenice od cigli sa mahovinom",
  "block.minecraft.mossy_stone_brick_wall": "Zid od kamenih cigli sa mahovinom",
  "block.minecraft.mossy_stone_bricks": "Kamene cigle prekrivene mahovinom",
  "block.minecraft.moving_piston": "Pomerajući klip",
  "block.minecraft.mud": "Blato",
  "block.minecraft.mud_brick_slab": "Ćerpična ploča",
  "block.minecraft.mud_brick_stairs": "Ćerpične cigle",
  "block.minecraft.mud_brick_wall": "Ćerpični zid",
  "block.minecraft.mud_bricks": "Ćerpič",
  "block.minecraft.muddy_mangrove_roots": "Blatnjavo korenje mangrova",
  "block.minecraft.mushroom_stem": "Stabljika pečurke",
  "block.minecraft.mycelium": "Micelijum",
  "block.minecraft.nether_brick_fence": "Ograda od Nether cigli",
  "block.minecraft.nether_brick_slab": "Nether ciglena ploča",
  "block.minecraft.nether_brick_stairs": "Stepenice od Nether cigli",
  "block.minecraft.nether_brick_wall": "Zid od cigli iz Nethera",
  "block.minecraft.nether_bricks": "Nether cigle",
  "block.minecraft.nether_gold_ore": "Ruda Nether zlata",
  "block.minecraft.nether_portal": "Nether portal",
  "block.minecraft.nether_quartz_ore": "Ruda Nether kvarca",
  "block.minecraft.nether_sprouts": "Nether klice",
  "block.minecraft.nether_wart": "Nether lišaj",
  "block.minecraft.nether_wart_block": "Blok Nether lišaja",
  "block.minecraft.netherite_block": "Blok Netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Muzički blok",
  "block.minecraft.oak_button": "Hrastovo dugme",
  "block.minecraft.oak_door": "Hrastova vrata",
  "block.minecraft.oak_fence": "Hrastova ograda",
  "block.minecraft.oak_fence_gate": "Hrastova kapija",
  "block.minecraft.oak_hanging_sign": "Hrastov viseći znak",
  "block.minecraft.oak_leaves": "Hrastovo lišće",
  "block.minecraft.oak_log": "Hrastov panj",
  "block.minecraft.oak_planks": "Hrastove daske",
  "block.minecraft.oak_pressure_plate": "Hrastova potisna ploča",
  "block.minecraft.oak_sapling": "Hrastove mladice",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Hrastov znak",
  "block.minecraft.oak_slab": "Hrastova ploča",
  "block.minecraft.oak_stairs": "Hrastove stepenice",
  "block.minecraft.oak_trapdoor": "Hrastovo okno",
  "block.minecraft.oak_wall_hanging_sign": "Hrastov zidni viseći znak",
  "block.minecraft.oak_wall_sign": "Hrastov zidni znak",
  "block.minecraft.oak_wood": "Hrastovina",
  "block.minecraft.observer": "Posmatrač",
  "block.minecraft.obsidian": "Obsidijan",
  "block.minecraft.ochre_froglight": "Oker žampa",
  "block.minecraft.ominous_banner": "Zloslutan barjak",
  "block.minecraft.open_eyeblossom": "Otvoren Cvet Očiju",
  "block.minecraft.orange_banner": "Narandžasta zastava",
  "block.minecraft.orange_bed": "Narandžasti krevet",
  "block.minecraft.orange_candle": "Narandžasta sveća",
  "block.minecraft.orange_candle_cake": "Torta sa narandžastom svećom",
  "block.minecraft.orange_carpet": "Narandžasti tepih",
  "block.minecraft.orange_concrete": "Narandžasti beton",
  "block.minecraft.orange_concrete_powder": "Narandžasti beton u prahu",
  "block.minecraft.orange_glazed_terracotta": "Terakota sa glazurom narandžaste",
  "block.minecraft.orange_shulker_box": "Narandžasta Shulker kutija",
  "block.minecraft.orange_stained_glass": "Narandžasto obojeno staklo",
  "block.minecraft.orange_stained_glass_pane": "Narandžasta staklena ploča",
  "block.minecraft.orange_terracotta": "Narandžasta terakota",
  "block.minecraft.orange_tulip": "Narandžasta lala",
  "block.minecraft.orange_wool": "Narandžasta vuna",
  "block.minecraft.oxeye_daisy": "Bela rada",
  "block.minecraft.oxidized_chiseled_copper": "Oksidovani Isklesani Bakar",
  "block.minecraft.oxidized_copper": "Oksidovani bakar",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oksidovana Bakarna Sijalica",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oksidovana Bakarna Vrata",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Rešetka od Oksidovanog Bakra",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Okno od oksidovanog bakra",
  "block.minecraft.oxidized_cut_copper": "Oksidovani sečeni bakar",
  "block.minecraft.oxidized_cut_copper_slab": "Oksidovana ploča od sečenog bakra",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksidovane stepenice od sečenog bakra",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Debeli led",
  "block.minecraft.packed_mud": "Debelo blato",
  "block.minecraft.pale_hanging_moss": "Bleda viseća mahovina",
  "block.minecraft.pale_moss_block": "Blok blede mahovine",
  "block.minecraft.pale_moss_carpet": "Tepih blede mahovine",
  "block.minecraft.pale_oak_button": "Bledo hrastovo dugme",
  "block.minecraft.pale_oak_door": "Bleda hrastova vrata",
  "block.minecraft.pale_oak_fence": "Bleda hrastova ograda",
  "block.minecraft.pale_oak_fence_gate": "Bleda hrastova kapija",
  "block.minecraft.pale_oak_hanging_sign": "Bledi hrastov viseći znak",
  "block.minecraft.pale_oak_leaves": "Bledo hrastovo lišće",
  "block.minecraft.pale_oak_log": "Bledi hrastov panj",
  "block.minecraft.pale_oak_planks": "Blede hrastove daske",
  "block.minecraft.pale_oak_pressure_plate": "Bledo hrastova potisna ploča",
  "block.minecraft.pale_oak_sapling": "Bleda hrastova mladica",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Bledi hrastov znak",
  "block.minecraft.pale_oak_slab": "Bleda hrastova ploča",
  "block.minecraft.pale_oak_stairs": "Blede hrastove stepenice",
  "block.minecraft.pale_oak_trapdoor": "Bledo hrastovo okno",
  "block.minecraft.pale_oak_wall_hanging_sign": "Bledi hrastov viseći znak",
  "block.minecraft.pale_oak_wall_sign": "Bledi hrastov zidni znak",
  "block.minecraft.pale_oak_wood": "Bleda hrastovina",
  "block.minecraft.pearlescent_froglight": "Biserna žampa",
  "block.minecraft.peony": "Božur",
  "block.minecraft.petrified_oak_slab": "Okamenjena hrastova ploča",
  "block.minecraft.piglin_head": "Piglinova glava",
  "block.minecraft.piglin_wall_head": "Piglinova glava za zid",
  "block.minecraft.pink_banner": "Roze zastava",
  "block.minecraft.pink_bed": "Roze krevet",
  "block.minecraft.pink_candle": "Roze sveća",
  "block.minecraft.pink_candle_cake": "Torta sa pink svećom",
  "block.minecraft.pink_carpet": "Roze tepih",
  "block.minecraft.pink_concrete": "Roze beton",
  "block.minecraft.pink_concrete_powder": "Roze beton u prahu",
  "block.minecraft.pink_glazed_terracotta": "Terakota sa roze glazurom",
  "block.minecraft.pink_petals": "Ružičaste latice",
  "block.minecraft.pink_shulker_box": "Roza Shulker kutija",
  "block.minecraft.pink_stained_glass": "Roze obojeno staklo",
  "block.minecraft.pink_stained_glass_pane": "Roze staklena ploča",
  "block.minecraft.pink_terracotta": "Roze terakota",
  "block.minecraft.pink_tulip": "Roze lala",
  "block.minecraft.pink_wool": "Roze vuna",
  "block.minecraft.piston": "Klip",
  "block.minecraft.piston_head": "Glava od klipa",
  "block.minecraft.pitcher_crop": "Sadnica vrča",
  "block.minecraft.pitcher_plant": "Biljka vrč",
  "block.minecraft.player_head": "Glava igrača",
  "block.minecraft.player_head.named": "Glava od \"%s\"",
  "block.minecraft.player_wall_head": "Zidna glava igrača",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Šiljati kapmen",
  "block.minecraft.polished_andesite": "Uglačani andezit",
  "block.minecraft.polished_andesite_slab": "Uglačana ploča od andezita",
  "block.minecraft.polished_andesite_stairs": "Uglačane stepenice od andezita",
  "block.minecraft.polished_basalt": "Uglačani bazalt",
  "block.minecraft.polished_blackstone": "Uglačana crna kaldrma",
  "block.minecraft.polished_blackstone_brick_slab": "Uglačana ploča od cigala crne kaldrme",
  "block.minecraft.polished_blackstone_brick_stairs": "Uglačane stepenice od cigala crne kaldrme",
  "block.minecraft.polished_blackstone_brick_wall": "Uglačani zid od cigala crne kaldrme",
  "block.minecraft.polished_blackstone_bricks": "Uglačane cigle od crne kaldrme",
  "block.minecraft.polished_blackstone_button": "Dugme od uglačane crne kaldrme",
  "block.minecraft.polished_blackstone_pressure_plate": "Potisna ploča od uglačane crne kaldrme",
  "block.minecraft.polished_blackstone_slab": "Ploča od uglačane crne kaldrme",
  "block.minecraft.polished_blackstone_stairs": "Stepenice od uglačane crne kaldrme",
  "block.minecraft.polished_blackstone_wall": "Zid od uglačane crne kaldrme",
  "block.minecraft.polished_deepslate": "Polirani škriljac",
  "block.minecraft.polished_deepslate_slab": "Ploča poliranog škriljca",
  "block.minecraft.polished_deepslate_stairs": "Stepenice poliranog škriljca",
  "block.minecraft.polished_deepslate_wall": "Zid poliranog škriljca",
  "block.minecraft.polished_diorite": "Uglačani diorit",
  "block.minecraft.polished_diorite_slab": "Uglačana ploča od diorita",
  "block.minecraft.polished_diorite_stairs": "Uglačane stepenice od diorita",
  "block.minecraft.polished_granite": "Uglačani granit",
  "block.minecraft.polished_granite_slab": "Uglačana ploča od granita",
  "block.minecraft.polished_granite_stairs": "Uglačane stepenice od granita",
  "block.minecraft.polished_tuff": "Uglačan tuf",
  "block.minecraft.polished_tuff_slab": "Uglačana tuf ploča",
  "block.minecraft.polished_tuff_stairs": "Uglačane tuf stepenice",
  "block.minecraft.polished_tuff_wall": "Zid od uglačanog tufa",
  "block.minecraft.poppy": "Mak",
  "block.minecraft.potatoes": "Krompiri",
  "block.minecraft.potted_acacia_sapling": "Zasađena mladica bagrema",
  "block.minecraft.potted_allium": "Alijum u saksiji",
  "block.minecraft.potted_azalea_bush": "Zasađena azaleja",
  "block.minecraft.potted_azure_bluet": "Hustonija u saksiji",
  "block.minecraft.potted_bamboo": "Bambus u saksiji",
  "block.minecraft.potted_birch_sapling": "Zasađena brezova mladica",
  "block.minecraft.potted_blue_orchid": "Plava orhideja u saksiji",
  "block.minecraft.potted_brown_mushroom": "Braon pečurka u saksiji",
  "block.minecraft.potted_cactus": "Zasađen kaktus",
  "block.minecraft.potted_cherry_sapling": "Zasađena trešnjina mladica",
  "block.minecraft.potted_closed_eyeblossom": "Saksiji zatvorenog cveta očiju",
  "block.minecraft.potted_cornflower": "Različak u saksiji",
  "block.minecraft.potted_crimson_fungus": "Grimizna gljiva u saksiji",
  "block.minecraft.potted_crimson_roots": "Grimizno korenje u saksiji",
  "block.minecraft.potted_dandelion": "Maslačak u saksiji",
  "block.minecraft.potted_dark_oak_sapling": "Zasađena mladica tamnog hrasta",
  "block.minecraft.potted_dead_bush": "Uveli žbun u saksiji",
  "block.minecraft.potted_fern": "Paprat u saksiji",
  "block.minecraft.potted_flowering_azalea_bush": "Cvetajuća zasađena azaleja",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Zasađena mladica prašumskog drveta",
  "block.minecraft.potted_lily_of_the_valley": "Đurđevak u saksiji",
  "block.minecraft.potted_mangrove_propagule": "Propagula mangrove u saksiji",
  "block.minecraft.potted_oak_sapling": "Zasađena hrastova mladica",
  "block.minecraft.potted_open_eyeblossom": "Otvoren cvet očiju u saksiji",
  "block.minecraft.potted_orange_tulip": "Narandžasta lala u saksiji",
  "block.minecraft.potted_oxeye_daisy": "Bela rada u saksiji",
  "block.minecraft.potted_pale_oak_sapling": "Bleda hrastova mladica u saksiji",
  "block.minecraft.potted_pink_tulip": "Roze lala u saksiji",
  "block.minecraft.potted_poppy": "Mak u saksiji",
  "block.minecraft.potted_red_mushroom": "Crvena pečurka u saksiji",
  "block.minecraft.potted_red_tulip": "Crvena lala u saksiji",
  "block.minecraft.potted_spruce_sapling": "Zasađena mladica smreke",
  "block.minecraft.potted_torchflower": "Bakljocvet u saksiji",
  "block.minecraft.potted_warped_fungus": "Izopačena gljiva u saksiji",
  "block.minecraft.potted_warped_roots": "Izopačeno korenje u saksiji",
  "block.minecraft.potted_white_tulip": "Bela lala u saksiji",
  "block.minecraft.potted_wither_rose": "Wither ruža u saksiji",
  "block.minecraft.powder_snow": "Sneg u prahu",
  "block.minecraft.powder_snow_cauldron": "Kotao sa snegom u prahu",
  "block.minecraft.powered_rail": "Pruga pod naponom",
  "block.minecraft.prismarine": "Prizmarin",
  "block.minecraft.prismarine_brick_slab": "Ploča od prizmarinskih cigli",
  "block.minecraft.prismarine_brick_stairs": "Stepenice od prizmarinskih cigli",
  "block.minecraft.prismarine_bricks": "Blok prizmarina",
  "block.minecraft.prismarine_slab": "Ploča prizmarina",
  "block.minecraft.prismarine_stairs": "Ctepenice prizmarina",
  "block.minecraft.prismarine_wall": "Zid od prizmarina",
  "block.minecraft.pumpkin": "Bundeva",
  "block.minecraft.pumpkin_stem": "Stabljika bundeve",
  "block.minecraft.purple_banner": "Ljubičasta zastava",
  "block.minecraft.purple_bed": "Ljubičast krevet",
  "block.minecraft.purple_candle": "Ljubičasta sveća",
  "block.minecraft.purple_candle_cake": "Torta sa ljubičastom svećom",
  "block.minecraft.purple_carpet": "Ljubičasti tepih",
  "block.minecraft.purple_concrete": "Ljubičasti beton",
  "block.minecraft.purple_concrete_powder": "Ljubičasti beton u prahu",
  "block.minecraft.purple_glazed_terracotta": "Terakota sa glazurom ljubičaste",
  "block.minecraft.purple_shulker_box": "Ljubičasta Shulker kutija",
  "block.minecraft.purple_stained_glass": "Ljubičasto obojeno staklo",
  "block.minecraft.purple_stained_glass_pane": "Ljubičasta staklena ploča",
  "block.minecraft.purple_terracotta": "Ljubičasta terakota",
  "block.minecraft.purple_wool": "Ljubičasta vuna",
  "block.minecraft.purpur_block": "Purpur blok",
  "block.minecraft.purpur_pillar": "Purpur stub",
  "block.minecraft.purpur_slab": "Purpur ploča",
  "block.minecraft.purpur_stairs": "Purpur stepenice",
  "block.minecraft.quartz_block": "Blok kvarca",
  "block.minecraft.quartz_bricks": "Cigle od kvarca",
  "block.minecraft.quartz_pillar": "Stub od kvarca",
  "block.minecraft.quartz_slab": "Ploča od kvarca",
  "block.minecraft.quartz_stairs": "Stepenice od kvarca",
  "block.minecraft.rail": "Pruga",
  "block.minecraft.raw_copper_block": "Blok sirovog bakra",
  "block.minecraft.raw_gold_block": "Blok sirovog zlata",
  "block.minecraft.raw_iron_block": "Blok sirovog gvožđa",
  "block.minecraft.red_banner": "Crvena zastava",
  "block.minecraft.red_bed": "Crven krevet",
  "block.minecraft.red_candle": "Crvena sveća",
  "block.minecraft.red_candle_cake": "Torta sa crvenom svećom",
  "block.minecraft.red_carpet": "Crveni tepih",
  "block.minecraft.red_concrete": "Crveni beton",
  "block.minecraft.red_concrete_powder": "Crveni beton u prahu",
  "block.minecraft.red_glazed_terracotta": "Terakota sa glazurom crvene",
  "block.minecraft.red_mushroom": "Crvena pečurka",
  "block.minecraft.red_mushroom_block": "Blok crvene pečurke",
  "block.minecraft.red_nether_brick_slab": "Crvena nether ciglena ploča",
  "block.minecraft.red_nether_brick_stairs": "Stepenice od crvenih Nether cigli",
  "block.minecraft.red_nether_brick_wall": "Zid od crvenih cigli iz Nethera",
  "block.minecraft.red_nether_bricks": "Crvene Nether cigle",
  "block.minecraft.red_sand": "Crveni pesak",
  "block.minecraft.red_sandstone": "Crveni peščar",
  "block.minecraft.red_sandstone_slab": "Ploča crvenog peščara",
  "block.minecraft.red_sandstone_stairs": "Stepenice crvenog peščara",
  "block.minecraft.red_sandstone_wall": "Zid od crvenog peščara",
  "block.minecraft.red_shulker_box": "Crvena Shulker kutija",
  "block.minecraft.red_stained_glass": "Crveno obojeno staklo",
  "block.minecraft.red_stained_glass_pane": "Crvena staklena ploča",
  "block.minecraft.red_terracotta": "Crvena terakota",
  "block.minecraft.red_tulip": "Crvena lala",
  "block.minecraft.red_wool": "Crvena vuna",
  "block.minecraft.redstone_block": "Redstone blok",
  "block.minecraft.redstone_lamp": "Redstone lampa",
  "block.minecraft.redstone_ore": "Redstone ruda",
  "block.minecraft.redstone_torch": "Redstone baklja",
  "block.minecraft.redstone_wall_torch": "Zidna redstone baklja",
  "block.minecraft.redstone_wire": "Redstone žica",
  "block.minecraft.reinforced_deepslate": "Ojačani škriljac",
  "block.minecraft.repeater": "Redstone pojačivač",
  "block.minecraft.repeating_command_block": "Ponavljajući komandni blok",
  "block.minecraft.resin_block": "Blok smole",
  "block.minecraft.resin_brick_slab": "Ploča od ciglene smole",
  "block.minecraft.resin_brick_stairs": "Stepenice od ciglene smole",
  "block.minecraft.resin_brick_wall": "Zid od ciglene smole",
  "block.minecraft.resin_bricks": "Cigle od smole",
  "block.minecraft.resin_clump": "Grumen smole",
  "block.minecraft.respawn_anchor": "Reinkarnaciono sidro",
  "block.minecraft.rooted_dirt": "Ukorenjena zemlja",
  "block.minecraft.rose_bush": "Žbun ruža",
  "block.minecraft.sand": "Pesak",
  "block.minecraft.sandstone": "Peščar",
  "block.minecraft.sandstone_slab": "Peščarska ploča",
  "block.minecraft.sandstone_stairs": "Stepenice od peščara",
  "block.minecraft.sandstone_wall": "Zid od peščara",
  "block.minecraft.scaffolding": "Skele",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk katalizator",
  "block.minecraft.sculk_sensor": "Sculk senzor",
  "block.minecraft.sculk_shrieker": "Sculk vrištač",
  "block.minecraft.sculk_vein": "Sculk žila",
  "block.minecraft.sea_lantern": "Morski fenjer",
  "block.minecraft.sea_pickle": "Morski krastavac",
  "block.minecraft.seagrass": "Morska trava",
  "block.minecraft.set_spawn": "Postavljena tačka reinkarnacije",
  "block.minecraft.short_dry_grass": "Niska osušena trava",
  "block.minecraft.short_grass": "Niska trava",
  "block.minecraft.shroomlight": "Svetlopečurka",
  "block.minecraft.shulker_box": "Shulker kutija",
  "block.minecraft.skeleton_skull": "Kosturova lobanja",
  "block.minecraft.skeleton_wall_skull": "Zidna kosturova lobanja",
  "block.minecraft.slime_block": "Blok sluzi",
  "block.minecraft.small_amethyst_bud": "Mali pupoljak ametista",
  "block.minecraft.small_dripleaf": "Mali kap-list",
  "block.minecraft.smithing_table": "Kovački sto",
  "block.minecraft.smoker": "Pušnica",
  "block.minecraft.smooth_basalt": "Glatki bazalt",
  "block.minecraft.smooth_quartz": "Gladak blok kvarca",
  "block.minecraft.smooth_quartz_slab": "Glatka ploča od kvarca",
  "block.minecraft.smooth_quartz_stairs": "Glatke stepenice od kvarca",
  "block.minecraft.smooth_red_sandstone": "Gladak crveni peškar",
  "block.minecraft.smooth_red_sandstone_slab": "Glatka ploča od crvenog peščara",
  "block.minecraft.smooth_red_sandstone_stairs": "Glatke stepenice od crvenog peščara",
  "block.minecraft.smooth_sandstone": "Gladak peščar",
  "block.minecraft.smooth_sandstone_slab": "Glatka ploča od peščara",
  "block.minecraft.smooth_sandstone_stairs": "Glatke stepenice od peščara",
  "block.minecraft.smooth_stone": "Gladak kamen",
  "block.minecraft.smooth_stone_slab": "Glatka kamena ploča",
  "block.minecraft.sniffer_egg": "Njuškalovo jaje",
  "block.minecraft.snow": "Sneg",
  "block.minecraft.snow_block": "Snežni blok",
  "block.minecraft.soul_campfire": "Duševna logorska vatra",
  "block.minecraft.soul_fire": "Duševna vatra",
  "block.minecraft.soul_lantern": "Fenjer duša",
  "block.minecraft.soul_sand": "Pesak duša",
  "block.minecraft.soul_soil": "Duševno tlo",
  "block.minecraft.soul_torch": "Baklja duša",
  "block.minecraft.soul_wall_torch": "Zidna baklja duši",
  "block.minecraft.spawn.not_valid": "Krevet ili napunjeno reinkarnaciono sidro ne postoji, ili je uništeno",
  "block.minecraft.spawner": "Generator čudovišta",
  "block.minecraft.spawner.desc1": "Interakcija sa jajetom za stvaranje:",
  "block.minecraft.spawner.desc2": "Postavlja vrstu stvorenja",
  "block.minecraft.sponge": "Sunđer",
  "block.minecraft.spore_blossom": "Pupoljak spore",
  "block.minecraft.spruce_button": "Dugme od smreke",
  "block.minecraft.spruce_door": "Vrata od smreke",
  "block.minecraft.spruce_fence": "Ograda od smreke",
  "block.minecraft.spruce_fence_gate": "Kapija od smreke",
  "block.minecraft.spruce_hanging_sign": "Smrekin viseći znak",
  "block.minecraft.spruce_leaves": "Lišće smreke",
  "block.minecraft.spruce_log": "Smreka",
  "block.minecraft.spruce_planks": "Daske od smreke",
  "block.minecraft.spruce_pressure_plate": "Potisna ploča od smreke",
  "block.minecraft.spruce_sapling": "Mladica smreke",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Znak od smreke",
  "block.minecraft.spruce_slab": "Ploča od smreke",
  "block.minecraft.spruce_stairs": "Stepenice od smreke",
  "block.minecraft.spruce_trapdoor": "Okno od smreke",
  "block.minecraft.spruce_wall_hanging_sign": "Omorikin zidni viseći znak",
  "block.minecraft.spruce_wall_sign": "Znak od smreke za zid",
  "block.minecraft.spruce_wood": "Drvo smreke",
  "block.minecraft.sticky_piston": "Lepljivi klip",
  "block.minecraft.stone": "Kamen",
  "block.minecraft.stone_brick_slab": "Ploča od kamenih cigala",
  "block.minecraft.stone_brick_stairs": "Stepenice od kamene cigle",
  "block.minecraft.stone_brick_wall": "Zid od kamenih cigli",
  "block.minecraft.stone_bricks": "Kamene cigle",
  "block.minecraft.stone_button": "Kameno dugme",
  "block.minecraft.stone_pressure_plate": "Kamena potisna ploča",
  "block.minecraft.stone_slab": "Kamena ploča",
  "block.minecraft.stone_stairs": "Stepenice od kamenja",
  "block.minecraft.stonecutter": "Rezač kamena",
  "block.minecraft.stripped_acacia_log": "Oguljena akacija",
  "block.minecraft.stripped_acacia_wood": "Oguljeno drvo bagrema",
  "block.minecraft.stripped_bamboo_block": "Blok od oguljenog bambusa",
  "block.minecraft.stripped_birch_log": "Oguljen brezov panj",
  "block.minecraft.stripped_birch_wood": "Oguljena brezovina",
  "block.minecraft.stripped_cherry_log": "Oguljeno trešnjino drvo",
  "block.minecraft.stripped_cherry_wood": "Oguljeno trešnjino drvo",
  "block.minecraft.stripped_crimson_hyphae": "Oguljena grimizna hifa",
  "block.minecraft.stripped_crimson_stem": "Oguljena grimizna stabljika",
  "block.minecraft.stripped_dark_oak_log": "Oguljeni tamni hrastov panj",
  "block.minecraft.stripped_dark_oak_wood": "Oguljena tamna hrastovina",
  "block.minecraft.stripped_jungle_log": "Oguljeno prašumsko drvo",
  "block.minecraft.stripped_jungle_wood": "Oguljeno prašumsko drvo",
  "block.minecraft.stripped_mangrove_log": "Ogyljena mangrova",
  "block.minecraft.stripped_mangrove_wood": "Oguljeno drvo mangrova",
  "block.minecraft.stripped_oak_log": "Oguljeni hrastov panj",
  "block.minecraft.stripped_oak_wood": "Oguljena hrastovina",
  "block.minecraft.stripped_pale_oak_log": "Oguljeni bledi hrastov panj",
  "block.minecraft.stripped_pale_oak_wood": "Oguljena bleda hrastovina",
  "block.minecraft.stripped_spruce_log": "Oguljena smreka",
  "block.minecraft.stripped_spruce_wood": "Oguljeno drvo smreke",
  "block.minecraft.stripped_warped_hyphae": "Oguljena izopačena hifa",
  "block.minecraft.stripped_warped_stem": "Oguljena izopačena stabljika",
  "block.minecraft.structure_block": "Strukturni blok",
  "block.minecraft.structure_void": "Strukturna praznina",
  "block.minecraft.sugar_cane": "Šećerna trska",
  "block.minecraft.sunflower": "Suncokret",
  "block.minecraft.suspicious_gravel": "Sumnjivi šljunak",
  "block.minecraft.suspicious_sand": "Sumnjivi pesak",
  "block.minecraft.sweet_berry_bush": "Slatki žbun bobica",
  "block.minecraft.tall_dry_grass": "Visoka osušena trava",
  "block.minecraft.tall_grass": "Visoka trava",
  "block.minecraft.tall_seagrass": "Visoka morska trava",
  "block.minecraft.target": "Meta",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Testni blok",
  "block.minecraft.test_instance_block": "Blok test instance",
  "block.minecraft.tinted_glass": "Zamagljeno staklo",
  "block.minecraft.tnt": "Dinamit",
  "block.minecraft.tnt.disabled": "TNT eksplozije su isključene",
  "block.minecraft.torch": "Baklja",
  "block.minecraft.torchflower": "Bakljocvet",
  "block.minecraft.torchflower_crop": "Usev bakljocveta",
  "block.minecraft.trapped_chest": "Kovčeg sa zamkom",
  "block.minecraft.trial_spawner": "Izazovni stvarač",
  "block.minecraft.tripwire": "Nagazna žica",
  "block.minecraft.tripwire_hook": "Kuka za nagaznu žicu",
  "block.minecraft.tube_coral": "Cevasti koral",
  "block.minecraft.tube_coral_block": "Blok cevastog korala",
  "block.minecraft.tube_coral_fan": "Cevasta koralna lepeza",
  "block.minecraft.tube_coral_wall_fan": "Cevasta koralna zidna lepeza",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Ploča od ciglenog tufa",
  "block.minecraft.tuff_brick_stairs": "Stepenice od ciglenog tufa",
  "block.minecraft.tuff_brick_wall": "Zid od ciglenog tufa",
  "block.minecraft.tuff_bricks": "Tuf cigle",
  "block.minecraft.tuff_slab": "Tuf ploča",
  "block.minecraft.tuff_stairs": "Stepenice od tufa",
  "block.minecraft.tuff_wall": "Zid od tufa",
  "block.minecraft.turtle_egg": "Kornjačino jaje",
  "block.minecraft.twisting_vines": "Uvrnute lijane",
  "block.minecraft.twisting_vines_plant": "Biljka uvrnute lijane",
  "block.minecraft.vault": "Trezor",
  "block.minecraft.verdant_froglight": "Zelena žampa",
  "block.minecraft.vine": "Lijane",
  "block.minecraft.void_air": "Prazni vazduh",
  "block.minecraft.wall_torch": "Zidna baklja",
  "block.minecraft.warped_button": "Izopačeno dugme",
  "block.minecraft.warped_door": "Izopačena vrata",
  "block.minecraft.warped_fence": "Izopačena ograda",
  "block.minecraft.warped_fence_gate": "Izopačena kapija",
  "block.minecraft.warped_fungus": "Izopačena gljiva",
  "block.minecraft.warped_hanging_sign": "Izopačeni viseći znak",
  "block.minecraft.warped_hyphae": "Izopačena hifa",
  "block.minecraft.warped_nylium": "Izopačeni nilijum",
  "block.minecraft.warped_planks": "Izopačene daske",
  "block.minecraft.warped_pressure_plate": "Izopačena potisna ploča",
  "block.minecraft.warped_roots": "Izopačeno korenje",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Izopačeni znak",
  "block.minecraft.warped_slab": "Izopačena ploča",
  "block.minecraft.warped_stairs": "Izopačene stepenice",
  "block.minecraft.warped_stem": "Izopačena stabljika",
  "block.minecraft.warped_trapdoor": "Izopačeno okno",
  "block.minecraft.warped_wall_hanging_sign": "Izopačeni zidni viseći znak",
  "block.minecraft.warped_wall_sign": "Izopačen zidni znak",
  "block.minecraft.warped_wart_block": "Izopačeni Blok od Lišajeva",
  "block.minecraft.water": "Voda",
  "block.minecraft.water_cauldron": "Kotao vode",
  "block.minecraft.waxed_chiseled_copper": "Isklesani bakar obložen voskom",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Blok bakra obložen voskom",
  "block.minecraft.waxed_copper_bulb": "Bakarna sijalica obložena voskom",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Bakarna vrata obložena voskom",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Bakarna rešetka obložena voskom",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Bakarno okno obloženo voskom",
  "block.minecraft.waxed_cut_copper": "Sečeni bakar obložen voskom",
  "block.minecraft.waxed_cut_copper_slab": "Ploča od sečenog bakra obložena voskom",
  "block.minecraft.waxed_cut_copper_stairs": "Stepenice od sečenog bakra obložene voskom",
  "block.minecraft.waxed_exposed_chiseled_copper": "Izloženi isklesani bakar obložen voskom",
  "block.minecraft.waxed_exposed_copper": "Izloženi bakar obložen voskom",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Izložena bakarna sijalica obložena voskom",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Izložena bakarna vrata obložena voskom",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Izložena bakarna rešetka obložena voskom",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Izloženo bakarno okno obloženo voskom",
  "block.minecraft.waxed_exposed_cut_copper": "Izloženi sečeni bakar obložen voskom",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Izložena ploča od sečenog bakra obložena voskom",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Izložene stepenice od sečenog bakra obložene voskom",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Oksidovani isklesani bakar obložen voskom",
  "block.minecraft.waxed_oxidized_copper": "Oksidovani bakar obložen voskom",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Oksidovana bakarna sijalica obložena voskom",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Oksidovana bakarna vrata obložena voskom",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Oksidovana bakarna rešetka obložena voskom",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Oksidovano bakarno okno obloženo voskom",
  "block.minecraft.waxed_oxidized_cut_copper": "Oksidovani sečeni bakar obložen voskom",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Oksidovana ploča od sečenog bakra obložena voskom",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Stepenice od sečenog bakra obložene voskom",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Zastareli bakar obložen voskom",
  "block.minecraft.waxed_weathered_copper": "Zastareli bakar obložen voskom",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Zastarela bakarna sijalica obložena voskom",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Zastarela bakarna vrata obložena voskom",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Zastarela bakarna rešetka obložena voskom",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Zastarelo bakarno okno obloženo voskom",
  "block.minecraft.waxed_weathered_cut_copper": "Zastareli sečeni bakar obložen voskom",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Zastarela ploča od sečenog bakra obložena voskom",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Zastarele stepenice od sečenog bakra obložene voskom",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Zastareli isklesani bakar",
  "block.minecraft.weathered_copper": "Oksidovan bakar",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Zastarela bakarna sijalica",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Zastarela bakarna vrata",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Zastarela bakarna rešetka",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Zastarelo bakarno okno",
  "block.minecraft.weathered_cut_copper": "Oksidovan sečeni bakar",
  "block.minecraft.weathered_cut_copper_slab": "Oksidovana ploča od sečenog bakra",
  "block.minecraft.weathered_cut_copper_stairs": "Oksidovane stepenice od sečenog bakra",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Jecajuće lijane",
  "block.minecraft.weeping_vines_plant": "Biljka jecajuće lijane",
  "block.minecraft.wet_sponge": "Mokar sunđer",
  "block.minecraft.wheat": "Usev pšenice",
  "block.minecraft.white_banner": "Bela zastava",
  "block.minecraft.white_bed": "Beo krevet",
  "block.minecraft.white_candle": "Bela sveća",
  "block.minecraft.white_candle_cake": "Torta sa belom svećom",
  "block.minecraft.white_carpet": "Beli tepih",
  "block.minecraft.white_concrete": "Beli beton",
  "block.minecraft.white_concrete_powder": "Beli beton u prahu",
  "block.minecraft.white_glazed_terracotta": "Terakota sa glazurom bele",
  "block.minecraft.white_shulker_box": "Bela Shulker kutija",
  "block.minecraft.white_stained_glass": "Belo obojeno staklo",
  "block.minecraft.white_stained_glass_pane": "Bela staklena ploča",
  "block.minecraft.white_terracotta": "Bela terakota",
  "block.minecraft.white_tulip": "Bela lala",
  "block.minecraft.white_wool": "Bela vuna",
  "block.minecraft.wildflowers": "Vetrovka",
  "block.minecraft.wither_rose": "Wither ruža",
  "block.minecraft.wither_skeleton_skull": "Lobanja Wither kostura",
  "block.minecraft.wither_skeleton_wall_skull": "Zidna lobanja Wither kostura",
  "block.minecraft.yellow_banner": "Žuta zastava",
  "block.minecraft.yellow_bed": "Žut krevet",
  "block.minecraft.yellow_candle": "Žuta sveća",
  "block.minecraft.yellow_candle_cake": "Torta sa žutom svećom",
  "block.minecraft.yellow_carpet": "Žuti tepih",
  "block.minecraft.yellow_concrete": "Žuti beton",
  "block.minecraft.yellow_concrete_powder": "Žuti beton u prahu",
  "block.minecraft.yellow_glazed_terracotta": "Terakota sa glazurom žute",
  "block.minecraft.yellow_shulker_box": "Žuta Shulker kutija",
  "block.minecraft.yellow_stained_glass": "Žuto obojeno staklo",
  "block.minecraft.yellow_stained_glass_pane": "Žuta staklena ploča",
  "block.minecraft.yellow_terracotta": "Žuta terakota",
  "block.minecraft.yellow_wool": "Žuta vuna",
  "block.minecraft.zombie_head": "Glava zombija",
  "block.minecraft.zombie_wall_head": "Zidna glava zombija",
  "item.minecraft.acacia_boat": "Čamac od bagrema",
  "item.minecraft.acacia_chest_boat": "Čamac od bagrema sa kovčegom",
  "item.minecraft.allay_spawn_egg": "Jaje blaže",
  "item.minecraft.amethyst_shard": "Krhotina ametista",
  "item.minecraft.angler_pottery_shard": "Delić grnčarije \"Pecaroš\"",
  "item.minecraft.angler_pottery_sherd": "Delić grnčarije \"Pecaroš\"",
  "item.minecraft.apple": "Jabuka",
  "item.minecraft.archer_pottery_shard": "Delić grnčarije \"Strelac\"",
  "item.minecraft.archer_pottery_sherd": "Delić grnčarije \"Strelac\"",
  "item.minecraft.armadillo_scute": "Ploča oklopa armadila",
  "item.minecraft.armadillo_spawn_egg": "Jaje armadila",
  "item.minecraft.armor_stand": "Postolje za oklop",
  "item.minecraft.arms_up_pottery_shard": "Delić grnčarije \"Ruke u vis\"",
  "item.minecraft.arms_up_pottery_sherd": "Delić grnčarije „Ruke u vis”",
  "item.minecraft.arrow": "Strela",
  "item.minecraft.axolotl_bucket": "Kofa sa aksolotlom",
  "item.minecraft.axolotl_spawn_egg": "Jaje aksolotla",
  "item.minecraft.baked_potato": "Ispečen krompir",
  "item.minecraft.bamboo_chest_raft": "Bambusov splav sa kovčegom",
  "item.minecraft.bamboo_raft": "Bambusov splav",
  "item.minecraft.bat_spawn_egg": "Jaje slepog miša",
  "item.minecraft.bee_spawn_egg": "Jaje pčele",
  "item.minecraft.beef": "Sirova govedina",
  "item.minecraft.beetroot": "Cvekla",
  "item.minecraft.beetroot_seeds": "Seme cvekle",
  "item.minecraft.beetroot_soup": "Supa od cvekle",
  "item.minecraft.birch_boat": "Brezov čamac",
  "item.minecraft.birch_chest_boat": "Brezov čamac sa kovčegom",
  "item.minecraft.black_bundle": "Crni džak",
  "item.minecraft.black_dye": "Crna boja",
  "item.minecraft.black_harness": "Crni pojas",
  "item.minecraft.blade_pottery_shard": "Delić grnčarije „Sečivo”",
  "item.minecraft.blade_pottery_sherd": "Delić grnčarije „Sečivo”",
  "item.minecraft.blaze_powder": "Ognjeni prah",
  "item.minecraft.blaze_rod": "Ognjeni štap",
  "item.minecraft.blaze_spawn_egg": "Jaje ognjenog",
  "item.minecraft.blue_bundle": "Plavi džak",
  "item.minecraft.blue_dye": "Plava boja",
  "item.minecraft.blue_egg": "Plavo jaje",
  "item.minecraft.blue_harness": "Plavi pojas",
  "item.minecraft.bogged_spawn_egg": "Jaje Zaglibljenog",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Munja dekoracija oklopa",
  "item.minecraft.bone": "Kost",
  "item.minecraft.bone_meal": "Koštano brašno",
  "item.minecraft.book": "Knjiga",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Luk",
  "item.minecraft.bowl": "Činija",
  "item.minecraft.bread": "Hleb",
  "item.minecraft.breeze_rod": "Povetarac štap",
  "item.minecraft.breeze_spawn_egg": "Jaje Povetarca",
  "item.minecraft.brewer_pottery_shard": "Delić grnčarije \"Napitak\"",
  "item.minecraft.brewer_pottery_sherd": "Delić grnčarije \"Napitak\"",
  "item.minecraft.brewing_stand": "Samovar za napitke",
  "item.minecraft.brick": "Cigla",
  "item.minecraft.brown_bundle": "Braon džak",
  "item.minecraft.brown_dye": "Braon boja",
  "item.minecraft.brown_egg": "Braon jaje",
  "item.minecraft.brown_harness": "Braon pojas",
  "item.minecraft.brush": "Četkica",
  "item.minecraft.bucket": "Kofa",
  "item.minecraft.bundle": "Svežanj",
  "item.minecraft.bundle.empty": "Prazno",
  "item.minecraft.bundle.empty.description": "Može nositi mešoviti stek predmeta",
  "item.minecraft.bundle.full": "Pun",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Delić grnčarije \"Plamen\"",
  "item.minecraft.burn_pottery_sherd": "Delić grnčarije \"Plamen\"",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Jaje kamile",
  "item.minecraft.carrot": "Šargarepa",
  "item.minecraft.carrot_on_a_stick": "Šargarepa na štapu",
  "item.minecraft.cat_spawn_egg": "Jaje mačke",
  "item.minecraft.cauldron": "Kotao",
  "item.minecraft.cave_spider_spawn_egg": "Jaje pećinskog pauka",
  "item.minecraft.chainmail_boots": "Verižne čizme",
  "item.minecraft.chainmail_chestplate": "Verižnjača",
  "item.minecraft.chainmail_helmet": "Verižna kapuljača",
  "item.minecraft.chainmail_leggings": "Verižne nogavice",
  "item.minecraft.charcoal": "Drveni ugalj",
  "item.minecraft.cherry_boat": "Trešnjin čamac",
  "item.minecraft.cherry_chest_boat": "Trešnjin čamac sa kovčegom",
  "item.minecraft.chest_minecart": "Kolica sa kovčegom",
  "item.minecraft.chicken": "Sirova piletina",
  "item.minecraft.chicken_spawn_egg": "Jaje kokoške",
  "item.minecraft.chorus_fruit": "Horus voćka",
  "item.minecraft.clay_ball": "Glinena lopta",
  "item.minecraft.clock": "Sat",
  "item.minecraft.coal": "Ugalj",
  "item.minecraft.coast_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Obala dekoracija oklopa",
  "item.minecraft.cocoa_beans": "Kakao zrnevlje",
  "item.minecraft.cod": "Sirov bakalar",
  "item.minecraft.cod_bucket": "Kofa sa bakalarom",
  "item.minecraft.cod_spawn_egg": "Jaje bakalara",
  "item.minecraft.command_block_minecart": "Kolica sa komandnim blokom",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Biftek",
  "item.minecraft.cooked_chicken": "Pečeno pile",
  "item.minecraft.cooked_cod": "Kuvani bakalar",
  "item.minecraft.cooked_mutton": "Kuvana jagnjetina",
  "item.minecraft.cooked_porkchop": "Pečena krmenadla",
  "item.minecraft.cooked_rabbit": "Kuvani zec",
  "item.minecraft.cooked_salmon": "Kuvan losos",
  "item.minecraft.cookie": "Kolačić",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Bakarna poluga",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Jaje krave",
  "item.minecraft.creaking_spawn_egg": "Jaje Škripanja",
  "item.minecraft.creeper_banner_pattern": "Šara banera",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper simbol",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Creeper jaje",
  "item.minecraft.crossbow": "Samostrel",
  "item.minecraft.crossbow.projectile": "Projektil:",
  "item.minecraft.crossbow.projectile.multiple": "Projektil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projektil: %s",
  "item.minecraft.cyan_bundle": "Tirkizni džak",
  "item.minecraft.cyan_dye": "Tirkizna boja",
  "item.minecraft.cyan_harness": "Tirkizan pojas",
  "item.minecraft.danger_pottery_shard": "Delić grnčarije \"Opasnost\"",
  "item.minecraft.danger_pottery_sherd": "Delić grnčarije \"Opasnost\"",
  "item.minecraft.dark_oak_boat": "Tamni hrastov čamac",
  "item.minecraft.dark_oak_chest_boat": "Tamni hrastov čamac sa kovčegom",
  "item.minecraft.debug_stick": "Štap za debagovanje",
  "item.minecraft.debug_stick.empty": "%s nema osobina",
  "item.minecraft.debug_stick.select": "odabrano \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" na %s",
  "item.minecraft.diamond": "Dijamant",
  "item.minecraft.diamond_axe": "Dijamantska sekira",
  "item.minecraft.diamond_boots": "Dijamantske čizme",
  "item.minecraft.diamond_chestplate": "Dijamantski nagrudnik",
  "item.minecraft.diamond_helmet": "Dijamantski šlem",
  "item.minecraft.diamond_hoe": "Dijamantska motika",
  "item.minecraft.diamond_horse_armor": "Dijamantski konjski oklop",
  "item.minecraft.diamond_leggings": "Dijamantske pantalone",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Dijamantski kramp",
  "item.minecraft.diamond_shovel": "Dijamantska lopata",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Dijamantski mač",
  "item.minecraft.disc_fragment_5": "Komad ploče",
  "item.minecraft.disc_fragment_5.desc": "Muzička ploča - 5",
  "item.minecraft.dolphin_spawn_egg": "Jaje delfina",
  "item.minecraft.donkey_spawn_egg": "Jaje magarca",
  "item.minecraft.dragon_breath": "Zmajev dah",
  "item.minecraft.dried_kelp": "Osušena morska alga",
  "item.minecraft.drowned_spawn_egg": "Jaje utopljenika",
  "item.minecraft.dune_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dina dekoracija oklopa",
  "item.minecraft.echo_shard": "Krhotina eha",
  "item.minecraft.egg": "Jaje",
  "item.minecraft.elder_guardian_spawn_egg": "Jaje starog čuvara",
  "item.minecraft.elytra": "Krila",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Začarana knjiga",
  "item.minecraft.enchanted_golden_apple": "Začarana zlatna jabuka",
  "item.minecraft.end_crystal": "End kristal",
  "item.minecraft.ender_dragon_spawn_egg": "Jaje Ender zmaja",
  "item.minecraft.ender_eye": "Ender oko",
  "item.minecraft.ender_pearl": "Ender biser",
  "item.minecraft.enderman_spawn_egg": "Endermen jaje",
  "item.minecraft.endermite_spawn_egg": "Endermit jaje",
  "item.minecraft.evoker_spawn_egg": "Jaje prizivatelja",
  "item.minecraft.experience_bottle": "Čarobna boca",
  "item.minecraft.explorer_pottery_shard": "Delić grnčarije \"Istraživač\"",
  "item.minecraft.explorer_pottery_sherd": "Delić grnčarije \"Istraživač\"",
  "item.minecraft.eye_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Oko dekoracija za oklop",
  "item.minecraft.feather": "Pero",
  "item.minecraft.fermented_spider_eye": "Fermentisano paukovo oko",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Vatrena lopta",
  "item.minecraft.firework_rocket": "Vatrometska raketa",
  "item.minecraft.firework_rocket.flight": "Let traje:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Vatrometska zvezda",
  "item.minecraft.firework_star.black": "Crn",
  "item.minecraft.firework_star.blue": "Plav",
  "item.minecraft.firework_star.brown": "Braon",
  "item.minecraft.firework_star.custom_color": "Po želji",
  "item.minecraft.firework_star.cyan": "Tirkizna",
  "item.minecraft.firework_star.fade_to": "Pretopi u",
  "item.minecraft.firework_star.flicker": "Svetlucanje",
  "item.minecraft.firework_star.gray": "Siv",
  "item.minecraft.firework_star.green": "Zelen",
  "item.minecraft.firework_star.light_blue": "Svetloplava",
  "item.minecraft.firework_star.light_gray": "Svetlosiva",
  "item.minecraft.firework_star.lime": "Svetlozelena",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Narandžast",
  "item.minecraft.firework_star.pink": "Roze",
  "item.minecraft.firework_star.purple": "Ljubičasta",
  "item.minecraft.firework_star.red": "Crven",
  "item.minecraft.firework_star.shape": "Nepoznati oblik",
  "item.minecraft.firework_star.shape.burst": "Prasak",
  "item.minecraft.firework_star.shape.creeper": "Creeper oblik",
  "item.minecraft.firework_star.shape.large_ball": "Velika lopta",
  "item.minecraft.firework_star.shape.small_ball": "Mala lopta",
  "item.minecraft.firework_star.shape.star": "Oblik zvezde",
  "item.minecraft.firework_star.trail": "Trag",
  "item.minecraft.firework_star.white": "Beo",
  "item.minecraft.firework_star.yellow": "Žut",
  "item.minecraft.fishing_rod": "Štap za pecanje",
  "item.minecraft.flint": "Kremen",
  "item.minecraft.flint_and_steel": "Kremen i čelik",
  "item.minecraft.flow_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Tok dekoracija oklopa",
  "item.minecraft.flow_banner_pattern": "Šara banera",
  "item.minecraft.flow_banner_pattern.desc": "Protok",
  "item.minecraft.flow_banner_pattern.new": "Tok šara banera",
  "item.minecraft.flow_pottery_sherd": "Tok delić grnčarije",
  "item.minecraft.flower_banner_pattern": "Šara barjaka",
  "item.minecraft.flower_banner_pattern.desc": "Lik cveta",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Saksija",
  "item.minecraft.fox_spawn_egg": "Jaje lisice",
  "item.minecraft.friend_pottery_shard": "Delić grnčarije „Prijatelj”",
  "item.minecraft.friend_pottery_sherd": "Delić grnčarije „Prijatelj”",
  "item.minecraft.frog_spawn_egg": "Jaje žabe",
  "item.minecraft.furnace_minecart": "Kolica sa pećnicom",
  "item.minecraft.ghast_spawn_egg": "Ghast jaje",
  "item.minecraft.ghast_tear": "Ghast suza",
  "item.minecraft.glass_bottle": "Staklena boca",
  "item.minecraft.glistering_melon_slice": "Svetlucava kriška lubenice",
  "item.minecraft.globe_banner_pattern": "Šara barjaka",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globus šara banera",
  "item.minecraft.glow_berries": "Svetleće bobice",
  "item.minecraft.glow_ink_sac": "Svetleća vrećica sa mastilom",
  "item.minecraft.glow_item_frame": "Svetleći ram za predmete",
  "item.minecraft.glow_squid_spawn_egg": "Jaje svetleće lignje",
  "item.minecraft.glowstone_dust": "Prah žarkamena",
  "item.minecraft.goat_horn": "Kozji rog",
  "item.minecraft.goat_spawn_egg": "Jaje koze",
  "item.minecraft.gold_ingot": "Zlatna poluga",
  "item.minecraft.gold_nugget": "Grumen zlata",
  "item.minecraft.golden_apple": "Zlatna jabuka",
  "item.minecraft.golden_axe": "Zlatna sekira",
  "item.minecraft.golden_boots": "Zlatne čizme",
  "item.minecraft.golden_carrot": "Zlatna šargarepa",
  "item.minecraft.golden_chestplate": "Zlatni nagrudnik",
  "item.minecraft.golden_helmet": "Zlatni šlem",
  "item.minecraft.golden_hoe": "Zlatna motika",
  "item.minecraft.golden_horse_armor": "Zlatni konjski oklop",
  "item.minecraft.golden_leggings": "Zlatne pantalone",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Zlatni kramp",
  "item.minecraft.golden_shovel": "Zlatna lopata",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Zlatni mač",
  "item.minecraft.gray_bundle": "Sivi džak",
  "item.minecraft.gray_dye": "Siva boja",
  "item.minecraft.gray_harness": "Sivi pojas",
  "item.minecraft.green_bundle": "Zeleni džak",
  "item.minecraft.green_dye": "Zelena boja",
  "item.minecraft.green_harness": "Zeleni pojas",
  "item.minecraft.guardian_spawn_egg": "Jaje čuvara",
  "item.minecraft.gunpowder": "Barut",
  "item.minecraft.guster_banner_pattern": "Šara banera",
  "item.minecraft.guster_banner_pattern.desc": "Zapuh",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Srećni Ghast jaje",
  "item.minecraft.harness": "Pojas",
  "item.minecraft.heart_of_the_sea": "Srce mora",
  "item.minecraft.heart_pottery_shard": "Delić grnčarije \"Srce\"",
  "item.minecraft.heart_pottery_sherd": "Delić grnčarije \"Srce\"",
  "item.minecraft.heartbreak_pottery_shard": "Delić grnčarije „Slomljeno srce”",
  "item.minecraft.heartbreak_pottery_sherd": "Delić grnčarije „Slomljeno srce”",
  "item.minecraft.hoglin_spawn_egg": "Hoglin jaje",
  "item.minecraft.honey_bottle": "Boca meda",
  "item.minecraft.honeycomb": "Saće",
  "item.minecraft.hopper_minecart": "Kolica sa levkom",
  "item.minecraft.horse_spawn_egg": "Jaje konja",
  "item.minecraft.host_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Domaćin dekoracija oklopa",
  "item.minecraft.howl_pottery_shard": "Delić grnčarije \"Zavijanje\"",
  "item.minecraft.howl_pottery_sherd": "Delić grnčarije \"Zavijanje\"",
  "item.minecraft.husk_spawn_egg": "Jaje ljuske",
  "item.minecraft.ink_sac": "Vrećica sa mastilom",
  "item.minecraft.iron_axe": "Gvozdena sekira",
  "item.minecraft.iron_boots": "Gvozdene čizme",
  "item.minecraft.iron_chestplate": "Gvozdeni nagrudnik",
  "item.minecraft.iron_golem_spawn_egg": "Jaje gvozdenog golema",
  "item.minecraft.iron_helmet": "Gvozdeni šlem",
  "item.minecraft.iron_hoe": "Gvozdena motika",
  "item.minecraft.iron_horse_armor": "Gvozdeni konjski oklop",
  "item.minecraft.iron_ingot": "Gvozdena poluga",
  "item.minecraft.iron_leggings": "Gvozdene pantalone",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Grumen gvožđa",
  "item.minecraft.iron_pickaxe": "Gvozdeni kramp",
  "item.minecraft.iron_shovel": "Gvozdena lopata",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Gvozdeni mač",
  "item.minecraft.item_frame": "Ram za predmet",
  "item.minecraft.jungle_boat": "Čamac od prašumskog drveta",
  "item.minecraft.jungle_chest_boat": "Čamac od drveta džungle sa kovčegom",
  "item.minecraft.knowledge_book": "Knjiga znanja",
  "item.minecraft.lapis_lazuli": "Lapis lazuli",
  "item.minecraft.lava_bucket": "Kofa sa lavom",
  "item.minecraft.lead": "Povodac",
  "item.minecraft.leather": "Koža",
  "item.minecraft.leather_boots": "Kožne čizme",
  "item.minecraft.leather_chestplate": "Kožni prsluk",
  "item.minecraft.leather_helmet": "Kožna kapa",
  "item.minecraft.leather_horse_armor": "Kožni konjski oklop",
  "item.minecraft.leather_leggings": "Kožne pantalone",
  "item.minecraft.light_blue_bundle": "Svetlo plavi džak",
  "item.minecraft.light_blue_dye": "Svetloplava boja",
  "item.minecraft.light_blue_harness": "Svetloplavi pojas",
  "item.minecraft.light_gray_bundle": "Svetlosiva sveća",
  "item.minecraft.light_gray_dye": "Svetlosiva boja",
  "item.minecraft.light_gray_harness": "Svetlosivi pojas",
  "item.minecraft.lime_bundle": "Svetlozeleni džak",
  "item.minecraft.lime_dye": "Svetlozelena boja",
  "item.minecraft.lime_harness": "Svetlozeleni pojas",
  "item.minecraft.lingering_potion": "Dugortajni napitak",
  "item.minecraft.lingering_potion.effect.awkward": "Neugodni dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.empty": "Dugotrajni nenapravljiv napitak",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Dugotrajni napitak otpornosti na vodu",
  "item.minecraft.lingering_potion.effect.harming": "Dugotrajni napitak povređivanja",
  "item.minecraft.lingering_potion.effect.healing": "Dugotrajni napitak lečenja",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Dugotrajni napitak nevidljivosti",
  "item.minecraft.lingering_potion.effect.leaping": "Dugotrajni napitak skakanja",
  "item.minecraft.lingering_potion.effect.levitation": "Dugotrajni napitak levitacije",
  "item.minecraft.lingering_potion.effect.luck": "Dugotrajni napitak sreće",
  "item.minecraft.lingering_potion.effect.mundane": "Obični dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.night_vision": "Dugotrajni napitak noćnog vida",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Dugotrajni napitak trovanja",
  "item.minecraft.lingering_potion.effect.regeneration": "Dugotrajni napitak regeneracije",
  "item.minecraft.lingering_potion.effect.slow_falling": "Dugotrajni napitak sporog padanja",
  "item.minecraft.lingering_potion.effect.slowness": "Dugotrajni napitak sporosti",
  "item.minecraft.lingering_potion.effect.strength": "Dugotrajni napitak snage",
  "item.minecraft.lingering_potion.effect.swiftness": "Dugotrajni napitak brzine",
  "item.minecraft.lingering_potion.effect.thick": "Gusti dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.turtle_master": "Dugotrajni napitak gospodara kornjače",
  "item.minecraft.lingering_potion.effect.water": "Dugotrajna vodena boca",
  "item.minecraft.lingering_potion.effect.water_breathing": "Dugotrajni napitak disanja pod vodom",
  "item.minecraft.lingering_potion.effect.weakness": "Dugotrajni napitak slabosti",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Jaje lame",
  "item.minecraft.lodestone_compass": "Kompas za magnetit",
  "item.minecraft.mace": "Buzdovan",
  "item.minecraft.magenta_bundle": "Magenta džak",
  "item.minecraft.magenta_dye": "Magenta boja",
  "item.minecraft.magenta_harness": "Magenta pojas",
  "item.minecraft.magma_cream": "Magma krem",
  "item.minecraft.magma_cube_spawn_egg": "Jaje kocke magme",
  "item.minecraft.mangrove_boat": "Čamac od mangrova",
  "item.minecraft.mangrove_chest_boat": "Čamac od mangrova sa kovčegom",
  "item.minecraft.map": "Prazna mapa",
  "item.minecraft.melon_seeds": "Seme lubenice",
  "item.minecraft.melon_slice": "Kriška lubenice",
  "item.minecraft.milk_bucket": "Kofa mleka",
  "item.minecraft.minecart": "Rudarska kolica",
  "item.minecraft.miner_pottery_shard": "Delić grnčarije \"Rudar\"",
  "item.minecraft.miner_pottery_sherd": "Delić grnčarije \"Rudar\"",
  "item.minecraft.mojang_banner_pattern": "Šara barjaka",
  "item.minecraft.mojang_banner_pattern.desc": "Stvar",
  "item.minecraft.mojang_banner_pattern.new": "Stvar šara banera",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom jaje",
  "item.minecraft.mourner_pottery_shard": "Delić grnčarije \"Žal\"",
  "item.minecraft.mourner_pottery_sherd": "Delić grnčarije \"Žal\"",
  "item.minecraft.mule_spawn_egg": "Jaje mazge",
  "item.minecraft.mushroom_stew": "Paprikaš od pečuraka",
  "item.minecraft.music_disc_11": "Muzička ploča",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Muzička ploča",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muzička ploča",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muzička ploča",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muzička ploča",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muzička ploča",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Muzička ploča",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Muzička ploča",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Muzička Kutija)",
  "item.minecraft.music_disc_far": "Muzička ploča",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Muzički disk\n",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muzička ploča",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muzička ploča",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muzička ploča",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine- otherside",
  "item.minecraft.music_disc_pigstep": "Muzička ploča",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Muzička ploča",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Muzička ploča",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Muzička ploča",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muzička ploča",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Muzički disk",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muzička ploča",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muzička ploča",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Sirova jagnjetina",
  "item.minecraft.name_tag": "Etiketa",
  "item.minecraft.nautilus_shell": "Nautilus školjka",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Nether cigla",
  "item.minecraft.nether_star": "Nether zvezda",
  "item.minecraft.nether_wart": "Nether lišaj",
  "item.minecraft.netherite_axe": "Netheritska sekira",
  "item.minecraft.netherite_boots": "Netheritske čizme",
  "item.minecraft.netherite_chestplate": "Netheritski nagrudnik",
  "item.minecraft.netherite_helmet": "Netheritska kaciga",
  "item.minecraft.netherite_hoe": "Netheritska motika",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netherit poluga",
  "item.minecraft.netherite_leggings": "Netheritske pantalone",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Netheritski kramp",
  "item.minecraft.netherite_scrap": "Odlomak netherita",
  "item.minecraft.netherite_shovel": "Netheritska lopata",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Netheritski mač",
  "item.minecraft.netherite_upgrade_smithing_template": "Kovački šablon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherit poboljšanje",
  "item.minecraft.oak_boat": "Hrastov čamac",
  "item.minecraft.oak_chest_boat": "Hrastov čamac sa kovčegom",
  "item.minecraft.ocelot_spawn_egg": "Jaje divlje mačke",
  "item.minecraft.ominous_bottle": "Zloslutna flaša",
  "item.minecraft.ominous_trial_key": "Zloslutni ključ izazova",
  "item.minecraft.orange_bundle": "Narandžasti džak",
  "item.minecraft.orange_dye": "Narandžasta boja",
  "item.minecraft.orange_harness": "Narandžasti pojas",
  "item.minecraft.painting": "Slika",
  "item.minecraft.pale_oak_boat": "Bledi hrastov čamac",
  "item.minecraft.pale_oak_chest_boat": "Bledi hrastov čamac sа kоvčegom",
  "item.minecraft.panda_spawn_egg": "Jaje pande",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Jaje papagaja",
  "item.minecraft.phantom_membrane": "Fantom membrana",
  "item.minecraft.phantom_spawn_egg": "Jaje fantoma",
  "item.minecraft.pig_spawn_egg": "Jaje svinje",
  "item.minecraft.piglin_banner_pattern": "Šara barjaka",
  "item.minecraft.piglin_banner_pattern.desc": "Njuška",
  "item.minecraft.piglin_banner_pattern.new": "Njuška šara banera",
  "item.minecraft.piglin_brute_spawn_egg": "Jaje surovog piglina",
  "item.minecraft.piglin_spawn_egg": "Jaje piglina",
  "item.minecraft.pillager_spawn_egg": "Jaje razbojnika",
  "item.minecraft.pink_bundle": "Roze džak",
  "item.minecraft.pink_dye": "Roze boja",
  "item.minecraft.pink_harness": "Roze pojas",
  "item.minecraft.pitcher_plant": "Biljka vrč",
  "item.minecraft.pitcher_pod": "Čaura vrča",
  "item.minecraft.plenty_pottery_shard": "Delić grnčarije \"Pregršt\"",
  "item.minecraft.plenty_pottery_sherd": "Delić grnčarije \"Pregršt\"",
  "item.minecraft.poisonous_potato": "Otrovni krompir",
  "item.minecraft.polar_bear_spawn_egg": "Jaje polarnog medveda",
  "item.minecraft.popped_chorus_fruit": "Napuklo horus voće",
  "item.minecraft.porkchop": "Sirova krmenadla",
  "item.minecraft.potato": "Krompir",
  "item.minecraft.potion": "Napitak",
  "item.minecraft.potion.effect.awkward": "Čudni napitak",
  "item.minecraft.potion.effect.empty": "Nenapravljiv napitak",
  "item.minecraft.potion.effect.fire_resistance": "Napitak otpornosti na vatru",
  "item.minecraft.potion.effect.harming": "Napitak povređivanja",
  "item.minecraft.potion.effect.healing": "Napitak lečenja",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Napitak nevidljivosti",
  "item.minecraft.potion.effect.leaping": "Napitak skakanja",
  "item.minecraft.potion.effect.levitation": "Napitak levitacije",
  "item.minecraft.potion.effect.luck": "Napitak sreće",
  "item.minecraft.potion.effect.mundane": "Obični napitak",
  "item.minecraft.potion.effect.night_vision": "Napitak noćnog vida",
  "item.minecraft.potion.effect.oozing": "Napitak curenja",
  "item.minecraft.potion.effect.poison": "Napitak trovanja",
  "item.minecraft.potion.effect.regeneration": "Napitak regeneracije",
  "item.minecraft.potion.effect.slow_falling": "Napitak sporog padanja",
  "item.minecraft.potion.effect.slowness": "Napitak sporosti",
  "item.minecraft.potion.effect.strength": "Napitak snage",
  "item.minecraft.potion.effect.swiftness": "Napitak brzine",
  "item.minecraft.potion.effect.thick": "Gusti napitak",
  "item.minecraft.potion.effect.turtle_master": "Napitak gospodara kornjače",
  "item.minecraft.potion.effect.water": "Boca sa vodom",
  "item.minecraft.potion.effect.water_breathing": "Napitak disanja pod vodom",
  "item.minecraft.potion.effect.weakness": "Napitak slabosti",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Delić grnčarije \"Strelac\"",
  "item.minecraft.pottery_shard_arms_up": "Delić grnčarije „Ruke u vis”",
  "item.minecraft.pottery_shard_prize": "Delić grnčarije „Nagrada”",
  "item.minecraft.pottery_shard_skull": "Delić grnčarije „Lobanja”",
  "item.minecraft.powder_snow_bucket": "Kofa sa snegom u prahu",
  "item.minecraft.prismarine_crystals": "Kristali prizmarina",
  "item.minecraft.prismarine_shard": "Krhotina prizmarina",
  "item.minecraft.prize_pottery_shard": "Delić grnčarije „Nagrada”",
  "item.minecraft.prize_pottery_sherd": "Delić grnčarije „Nagrada”",
  "item.minecraft.pufferfish": "Fugu riba",
  "item.minecraft.pufferfish_bucket": "Kofa Fugu ribe",
  "item.minecraft.pufferfish_spawn_egg": "Jaje fugu ribe",
  "item.minecraft.pumpkin_pie": "Pita od bundeve",
  "item.minecraft.pumpkin_seeds": "Seme bundeve",
  "item.minecraft.purple_bundle": "Ljubičasti džak",
  "item.minecraft.purple_dye": "Ljubičasta boja",
  "item.minecraft.purple_harness": "Ljubičast pojas",
  "item.minecraft.quartz": "Nether kvarc",
  "item.minecraft.rabbit": "Sirov zec",
  "item.minecraft.rabbit_foot": "Zečija šapa",
  "item.minecraft.rabbit_hide": "Zečije krzno",
  "item.minecraft.rabbit_spawn_egg": "Jaje zeca",
  "item.minecraft.rabbit_stew": "Zečiji paprikaš",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Staratelj dekoracija za oklop",
  "item.minecraft.ravager_spawn_egg": "Jaje razarača",
  "item.minecraft.raw_copper": "Sirovi bakar",
  "item.minecraft.raw_gold": "Sirovo zlato",
  "item.minecraft.raw_iron": "Sirovo gvožđe",
  "item.minecraft.recovery_compass": "Povratni kompas",
  "item.minecraft.red_bundle": "Crveni džak",
  "item.minecraft.red_dye": "Crvena boja",
  "item.minecraft.red_harness": "Crveni pojas",
  "item.minecraft.redstone": "Redstone prah",
  "item.minecraft.resin_brick": "Cigla smole",
  "item.minecraft.resin_clump": "Grumen smole",
  "item.minecraft.rib_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rebro dekoracija za oklop",
  "item.minecraft.rotten_flesh": "Trulo meso",
  "item.minecraft.saddle": "Sedlo",
  "item.minecraft.salmon": "Sirovi losos",
  "item.minecraft.salmon_bucket": "Kofa sa lososom",
  "item.minecraft.salmon_spawn_egg": "Jaje lososa",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Ploča oklopa",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Stražar dekoracija za oklop",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Oblikovatelj dekoracija za oklop",
  "item.minecraft.sheaf_pottery_shard": "Delić grnčarije \"Snop\"",
  "item.minecraft.sheaf_pottery_sherd": "Delić grnčarije \"Snop\"",
  "item.minecraft.shears": "Makaze",
  "item.minecraft.sheep_spawn_egg": "Jaje ovce",
  "item.minecraft.shelter_pottery_shard": "Delić grnčarije \"Sklonište\"",
  "item.minecraft.shelter_pottery_sherd": "Delić grnčarije \"Sklonište\"",
  "item.minecraft.shield": "Štit",
  "item.minecraft.shield.black": "Crni štit",
  "item.minecraft.shield.blue": "Plavi štit",
  "item.minecraft.shield.brown": "Braon štit",
  "item.minecraft.shield.cyan": "Tirkizni štit",
  "item.minecraft.shield.gray": "Sivi štit",
  "item.minecraft.shield.green": "Zeleni štit",
  "item.minecraft.shield.light_blue": "Svetloplavi štit",
  "item.minecraft.shield.light_gray": "Svetlosiv štit",
  "item.minecraft.shield.lime": "Svetlozeleni štit",
  "item.minecraft.shield.magenta": "Magenta štit",
  "item.minecraft.shield.orange": "Narandžasti štit",
  "item.minecraft.shield.pink": "Roze štit",
  "item.minecraft.shield.purple": "Ljubičasti štit",
  "item.minecraft.shield.red": "Crveni štit",
  "item.minecraft.shield.white": "Beli Štit",
  "item.minecraft.shield.yellow": "Žuti štit",
  "item.minecraft.shulker_shell": "Shulker ljuska",
  "item.minecraft.shulker_spawn_egg": "Jaje shulkera",
  "item.minecraft.sign": "Znak",
  "item.minecraft.silence_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Tišina dekoracija za oklop",
  "item.minecraft.silverfish_spawn_egg": "Jaje srebrne ribe",
  "item.minecraft.skeleton_horse_spawn_egg": "Jaje kostura konja",
  "item.minecraft.skeleton_spawn_egg": "Jaje kostura",
  "item.minecraft.skull_banner_pattern": "Šara barjaka",
  "item.minecraft.skull_banner_pattern.desc": "Lik lobanje",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Delić grnčarije \"Lobanja\"",
  "item.minecraft.skull_pottery_sherd": "Delić grnčarije \"Lobanja\"",
  "item.minecraft.slime_ball": "Lopta od sluzi",
  "item.minecraft.slime_spawn_egg": "Jaje sluzi",
  "item.minecraft.smithing_template": "Kovački šablon",
  "item.minecraft.smithing_template.applies_to": "Primenjuje se na:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Dodajte polugu ili kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Oklop",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Dodajte deo oklopa",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Poluge i kristali",
  "item.minecraft.smithing_template.ingredients": "Sastojci:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Dodaj nederit polugu",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Dijamantska oprema",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Dodaj dijamantski oklop, oružije ili alat",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Nederit poluga",
  "item.minecraft.smithing_template.upgrade": "Nadogradnje: ",
  "item.minecraft.sniffer_spawn_egg": "Jaje njuškala",
  "item.minecraft.snort_pottery_shard": "Delić grnčarije \"Njuška\"",
  "item.minecraft.snort_pottery_sherd": "Delić grnčarije \"Njuška\"",
  "item.minecraft.snout_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Njuška dekoracija za oklop",
  "item.minecraft.snow_golem_spawn_egg": "Jaje snežnog golema",
  "item.minecraft.snowball": "Grudva",
  "item.minecraft.spectral_arrow": "Spektralna strela",
  "item.minecraft.spider_eye": "Paukovo oko",
  "item.minecraft.spider_spawn_egg": "Jaje pauka",
  "item.minecraft.spire_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Kula dekoracija za oklop",
  "item.minecraft.splash_potion": "Rasprskujući napitak",
  "item.minecraft.splash_potion.effect.awkward": "Neugodni rasprskujući napitak",
  "item.minecraft.splash_potion.effect.empty": "Rasprskujući nenapravljivi napitak",
  "item.minecraft.splash_potion.effect.fire_resistance": "Rasprskujući napitak otpornosti na vatru",
  "item.minecraft.splash_potion.effect.harming": "Rasprskujući napitak povređivanja",
  "item.minecraft.splash_potion.effect.healing": "Rasprskujući napitak lečenja",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Rasprskujući napitak nevidljivosti",
  "item.minecraft.splash_potion.effect.leaping": "Rasprskujući napitak skakanja",
  "item.minecraft.splash_potion.effect.levitation": "Rasprskujući napitak levitacije",
  "item.minecraft.splash_potion.effect.luck": "Rasprskujući napitak sreće",
  "item.minecraft.splash_potion.effect.mundane": "Obični rasprskujući napitak",
  "item.minecraft.splash_potion.effect.night_vision": "Rasprskujući napitak noćnog vida",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Rasprskujući napitak trovanja",
  "item.minecraft.splash_potion.effect.regeneration": "Rasprskujući napitak otrova",
  "item.minecraft.splash_potion.effect.slow_falling": "Rasprskujući napitak sporog padanja",
  "item.minecraft.splash_potion.effect.slowness": "Rasprskujući napitak sporosti",
  "item.minecraft.splash_potion.effect.strength": "Rasprskujući napitak snage",
  "item.minecraft.splash_potion.effect.swiftness": "Rasprskujući napitak brzine",
  "item.minecraft.splash_potion.effect.thick": "Gusti rasprskujući napitak",
  "item.minecraft.splash_potion.effect.turtle_master": "Ofanzivni napitak gospodara kornjače",
  "item.minecraft.splash_potion.effect.water": "Rasprskujuća vodena boca",
  "item.minecraft.splash_potion.effect.water_breathing": "Rasprskujući napitak disanja pod vodom",
  "item.minecraft.splash_potion.effect.weakness": "Rasprskujući napitak slabosti",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Čamac od smreke",
  "item.minecraft.spruce_chest_boat": "Čamac od smreke sa kovčegom",
  "item.minecraft.spyglass": "Durbin",
  "item.minecraft.squid_spawn_egg": "Jaje lignje",
  "item.minecraft.stick": "Štap",
  "item.minecraft.stone_axe": "Kamena sekira",
  "item.minecraft.stone_hoe": "Kamena motika",
  "item.minecraft.stone_pickaxe": "Kameni kramp",
  "item.minecraft.stone_shovel": "Kamena lopata",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Kameni mač",
  "item.minecraft.stray_spawn_egg": "Jaje lutalice",
  "item.minecraft.strider_spawn_egg": "Jaje šetača",
  "item.minecraft.string": "Nit",
  "item.minecraft.sugar": "Šećer",
  "item.minecraft.suspicious_stew": "Sumnjivi paprikaš",
  "item.minecraft.sweet_berries": "Slatke bobice",
  "item.minecraft.tadpole_bucket": "Kofa sa punoglavcem",
  "item.minecraft.tadpole_spawn_egg": "Jaje punoglavca",
  "item.minecraft.tide_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Plima dekoracija za oklop",
  "item.minecraft.tipped_arrow": "Umočena strela",
  "item.minecraft.tipped_arrow.effect.awkward": "Umočena strela",
  "item.minecraft.tipped_arrow.effect.empty": "Nepravljena umočena strela",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Strela otpornosti na vatru",
  "item.minecraft.tipped_arrow.effect.harming": "Strela povređivanja",
  "item.minecraft.tipped_arrow.effect.healing": "Strela oporavljanja",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Strela nevidljivosti",
  "item.minecraft.tipped_arrow.effect.leaping": "Strela skakanja",
  "item.minecraft.tipped_arrow.effect.levitation": "Strela levitacije",
  "item.minecraft.tipped_arrow.effect.luck": "Strela sreće",
  "item.minecraft.tipped_arrow.effect.mundane": "Umočena strela",
  "item.minecraft.tipped_arrow.effect.night_vision": "Strela noćnog vida",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Strela otrova",
  "item.minecraft.tipped_arrow.effect.regeneration": "Strela regeneracije",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Strela sporog padanja",
  "item.minecraft.tipped_arrow.effect.slowness": "Strela sporosti",
  "item.minecraft.tipped_arrow.effect.strength": "Strela snage",
  "item.minecraft.tipped_arrow.effect.swiftness": "Strela brzine",
  "item.minecraft.tipped_arrow.effect.thick": "Umočena strela",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Strela gospodara kornjače",
  "item.minecraft.tipped_arrow.effect.water": "Strela rasprskivanja",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Strela disanja pod vodom",
  "item.minecraft.tipped_arrow.effect.weakness": "Strela slabosti",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Kolica sa dinamitom",
  "item.minecraft.torchflower_seeds": "Seme bakljocveta",
  "item.minecraft.totem_of_undying": "Totem besmrti",
  "item.minecraft.trader_llama_spawn_egg": "Jaje trgovačke lame",
  "item.minecraft.trial_key": "Ključ izazova",
  "item.minecraft.trident": "Trozubac",
  "item.minecraft.tropical_fish": "Tropska riba",
  "item.minecraft.tropical_fish_bucket": "Kofa sa tropskom ribom",
  "item.minecraft.tropical_fish_spawn_egg": "Jaje tropske ribe",
  "item.minecraft.turtle_helmet": "Kornjačin oklop",
  "item.minecraft.turtle_scute": "Ploča kornjačinog oklopa",
  "item.minecraft.turtle_spawn_egg": "Jaje kornjače",
  "item.minecraft.vex_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Napast dekoracija za oklop",
  "item.minecraft.vex_spawn_egg": "Jaje napasti",
  "item.minecraft.villager_spawn_egg": "Jaje seljaka",
  "item.minecraft.vindicator_spawn_egg": "Jaje osvetnika",
  "item.minecraft.wandering_trader_spawn_egg": "Jaje lutajućeg trgovca",
  "item.minecraft.ward_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Čuvar dekoracija za oklop",
  "item.minecraft.warden_spawn_egg": "Jaje stražara",
  "item.minecraft.warped_fungus_on_a_stick": "Izopačena gljiva na štapu",
  "item.minecraft.water_bucket": "Kofa sa vodom",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Putokaz dekoracija za oklop",
  "item.minecraft.wheat": "Pšenica",
  "item.minecraft.wheat_seeds": "Seme pšenice",
  "item.minecraft.white_bundle": "Beli džak",
  "item.minecraft.white_dye": "Bela boja",
  "item.minecraft.white_harness": "Beli pojas",
  "item.minecraft.wild_armor_trim_smithing_template": "Kovački šablon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Divlji dekoracija za oklop",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Jaje veštice",
  "item.minecraft.wither_skeleton_spawn_egg": "Jaje Wither kostura",
  "item.minecraft.wither_spawn_egg": "Wither-ovo jaje",
  "item.minecraft.wolf_armor": "Oklop za vuka",
  "item.minecraft.wolf_spawn_egg": "Jaje vuka",
  "item.minecraft.wooden_axe": "Drvena sekira",
  "item.minecraft.wooden_hoe": "Drvena motika",
  "item.minecraft.wooden_pickaxe": "Drveni kramp",
  "item.minecraft.wooden_shovel": "Drvena lopata",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Drveni mač",
  "item.minecraft.writable_book": "Knjiga i pero",
  "item.minecraft.written_book": "Napisana knjiga",
  "item.minecraft.yellow_bundle": "Žuti džak",
  "item.minecraft.yellow_dye": "Žuta boja",
  "item.minecraft.yellow_harness": "Žuti pojas",
  "item.minecraft.zoglin_spawn_egg": "Jaje zoglina",
  "item.minecraft.zombie_horse_spawn_egg": "Jaje zombi konja",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Jaje zombija",
  "item.minecraft.zombie_villager_spawn_egg": "Jaje zombi seljaka",
  "item.minecraft.zombified_piglin_spawn_egg": "Jaje zombifikovanog piglina"
}
export const sr_cs = items; 
